import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box, Typography, Tab, Tabs, CircularProgress, Chip, IconButton, Tooltip,
    Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, FormControl, InputLabel, Select, MenuItem, List, ListItem,
    ListItemIcon, ListItemText, Radio, RadioGroup, FormControlLabel, Checkbox,
    FormGroup, LinearProgress, SvgIcon, Menu
} from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import PersonIcon from "@mui/icons-material/Person";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DownloadReportModal from "./components/DownloadReportModal";
import { useDocumentTitle } from "../../../shared/OAWorkflow/utils/useDocumentTitle";

// Custom icons from Figma downloads
const AttachFileAddIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <mask id="mask0_attach" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_attach)">
            <path d="M16 11V6H18V11H16ZM11 17.9C10.4167 17.7333 9.9375 17.4083 9.5625 16.925C9.1875 16.4417 9 15.8833 9 15.25V6H11V17.9ZM11.75 22C10.0167 22 8.54167 21.3917 7.325 20.175C6.10833 18.9583 5.5 17.4833 5.5 15.75V6.5C5.5 5.25 5.9375 4.1875 6.8125 3.3125C7.6875 2.4375 8.75 2 10 2C11.25 2 12.3125 2.4375 13.1875 3.3125C14.0625 4.1875 14.5 5.25 14.5 6.5V14H12.5V6.5C12.4833 5.8 12.2375 5.20833 11.7625 4.725C11.2875 4.24167 10.7 4 10 4C9.3 4 8.70833 4.24167 8.225 4.725C7.74167 5.20833 7.5 5.8 7.5 6.5V15.75C7.48333 16.9333 7.89167 17.9375 8.725 18.7625C9.55833 19.5875 10.5667 20 11.75 20C12.1667 20 12.5625 19.9458 12.9375 19.8375C13.3125 19.7292 13.6667 19.5667 14 19.35V21.575C13.65 21.7083 13.2875 21.8125 12.9125 21.8875C12.5375 21.9625 12.15 22 11.75 22ZM16 21V18H13V16H16V13H18V16H21V18H18V21H16Z" fill="currentColor"/>
        </g>
    </SvgIcon>
);

const EditIconCustom = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <mask id="mask0_edit" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_edit)">
            <path d="M5 19H6.425L16.2 9.225L14.775 7.8L5 17.575V19ZM3 21V16.75L16.2 3.575C16.4 3.39167 16.6208 3.25 16.8625 3.15C17.1042 3.05 17.3583 3 17.625 3C17.8917 3 18.15 3.05 18.4 3.15C18.65 3.25 18.8667 3.4 19.05 3.6L20.425 5C20.625 5.18333 20.7708 5.4 20.8625 5.65C20.9542 5.9 21 6.15 21 6.4C21 6.66667 20.9542 6.92083 20.8625 7.1625C20.7708 7.40417 20.625 7.625 20.425 7.825L7.25 21H3ZM15.475 8.525L14.775 7.8L16.2 9.225L15.475 8.525Z" fill="currentColor"/>
        </g>
    </SvgIcon>
);

const AdsClickIconCustom = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <mask id="mask0_click" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_click)">
            <path d="M11.7 18C10.1 17.9167 8.75 17.3 7.65 16.15C6.55 15 6 13.6167 6 12C6 10.3333 6.58333 8.91667 7.75 7.75C8.91667 6.58333 10.3333 6 12 6C13.6167 6 15 6.55 16.15 7.65C17.3 8.75 17.9167 10.1 18 11.7L15.9 11.075C15.6833 10.175 15.2167 9.4375 14.5 8.8625C13.7833 8.2875 12.95 8 12 8C10.9 8 9.95833 8.39167 9.175 9.175C8.39167 9.95833 8 10.9 8 12C8 12.95 8.2875 13.7833 8.8625 14.5C9.4375 15.2167 10.175 15.6833 11.075 15.9L11.7 18ZM12.9 21.95C12.75 21.9833 12.6 22 12.45 22H12C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12V12.45C22 12.6 21.9833 12.75 21.95 12.9L20 12.3V12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20H12.3L12.9 21.95ZM20.525 22.5L16.25 18.225L15 22L12 12L22 15L18.225 16.25L22.5 20.525L20.525 22.5Z" fill="currentColor"/>
        </g>
    </SvgIcon>
);

const HowToRegIconCustom = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <mask id="mask0_reg" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_reg)">
            <path d="M2 20V17.2C2 16.65 2.14167 16.1333 2.425 15.65C2.70833 15.1657 3.1 14.8 3.6 14.55C4.45 14.1167 5.40833 13.75 6.475 13.45C7.54167 13.15 8.71667 13 10 13C10.5 13 10.9875 13.025 11.4625 13.075C11.9375 13.125 12.4 13.2 12.85 13.3L11.1 15.05C10.9167 15.0167 10.7375 15 10.5625 15H10C8.81667 15 7.75417 15.1417 6.8125 15.425C5.87083 15.7083 5.1 16.0167 4.5 16.35C4.35 16.4333 4.22917 16.55 4.1375 16.7C4.04583 16.85 4 17.0167 4 17.2V18H10.25L12.25 20H2ZM15.55 20.4L12.1 16.95L13.5 15.55L15.55 17.6L20.6 12.55L22 13.95L15.55 20.4ZM10 12C8.9 12 7.95833 11.6083 7.175 10.825C6.39167 10.0417 6 9.1 6 8C6 6.9 6.39167 5.95833 7.175 5.175C7.95833 4.39167 8.9 4 10 4C11.1 4 12.0417 4.39167 12.825 5.175C13.6083 5.95833 14 6.9 14 8C14 9.1 13.6083 10.0417 12.825 10.825C12.0417 11.6083 11.1 12 10 12ZM10 10C10.55 10 11.0208 9.80417 11.4125 9.4125C11.8042 9.02083 12 8.55 12 8C12 7.45 11.8042 6.97917 11.4125 6.5875C11.0208 6.19583 10.55 6 10 6C9.45 6 8.97917 6.19583 8.5875 6.5875C8.19583 6.97917 8 7.45 8 8C8 8.55 8.19583 9.02083 8.5875 9.4125C8.97917 9.80417 9.45 10 10 10Z" fill="currentColor"/>
        </g>
    </SvgIcon>
);
import HistoryIcon from "@mui/icons-material/History";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import SendIcon from "@mui/icons-material/Send";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import BoltIcon from "@mui/icons-material/Bolt";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { axios_tenant } from "../../../../axios";
import TaskTable from "../../../shared/OAWorkflow/components/TaskTable";
import ColumnPickerMenu from "../../../shared/OAWorkflow/components/ColumnPickerMenu";
import useGridColumnPrefs from "../../../shared/OAWorkflow/hooks/useGridColumnPrefs";
import OAPagination from "../../../shared/OAWorkflow/components/OAPagination";
import OASearchBar from "../../../shared/OAWorkflow/components/OASearchBar";
import TrackChangesModal from "../../../shared/OAWorkflow/components/TrackChangesModal";
import AssignDialog from "./components/AssignDialog";
import UpdateAssignmentModal from "./components/UpdateAssignmentModal";
import ManageUserModal from "../../../shared/OAWorkflow/components/ManageUserModal";
import Button from "../../../shared/OAWorkflow/components/atoms/Button";
import { TAB_STYLES, BRAND_COLORS, PGS_TASK_TABLE_COLUMNS, PGS_TASK_TABLE_COLUMNS_AFTER, TASK_STATUSES } from "../../../shared/OAWorkflow/constants/taskStatuses";
import { getDropdownOptions, getSubmitTransition, isSubmitEnabled, getSubmitDisabledReason, getSubmitConfirmMessage, canUploadFile, isProcessorLocked, isQaLocked, getEligibleUsers, hasRequiredPackages } from "../../../shared/OAWorkflow/utils/taskTransitions";
import { formatActivityLabel } from "../../../shared/OAWorkflow/utils/activityLabels";
import { formatDateDDMMMYYYY } from "../../../shared/OAWorkflow/utils/dateUtils";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import "./OAWorkflow.css";

const BASE_URL = "/collaboration/workflow";

// COL-153: one entry per grid column, in grid order, so the filter dropdown
// offers everything the table shows. Backend whitelist: FILTERABLE_FIELDS.
const PGS_SEARCH_FIELDS = [
    { value: "all", label: "All" },
    { value: "taskId", label: "Task ID" },
    { value: "routedClient", label: "Client Name" },
    { value: "applicationNo", label: "Application No." },
    { value: "patentNo", label: "Patent No." },
    { value: "supportType", label: "Support Type" },
    { value: "activityName", label: "Activity" },
    { value: "pageNo", label: "Page No." },
    { value: "complexity", label: "Complexity" },
    { value: "requestedDate", label: "Incoming Date" },
    { value: "deadlineDate", label: "Deadline" },
    { value: "sourceFile", label: "Source File" },
    { value: "taskStatus", label: "Task Status" },
    { value: "errorNoError", label: "Error / No Error" },
    { value: "processorName", label: "Processor" },
    { value: "qaName", label: "QA" },
    { value: "createdBy", label: "Created By" }
];

// COL-150: AM column customization. The selection is stored server-side under
// this grid key; these columns are always shown regardless of the selection.
const PGS_GRID_KEY = "pgs-tasks";
const PGS_MANDATORY_COLUMNS = ["taskId", "actions"];

// COL-157: shares the priority chip row but filters by status, not priority.
// Offered to Processor and QA on the Pending tab only, where it is the default
// selection; the backend decides which statuses from the caller's role.
const AWAITING_MY_ACTION = "AwaitingMyAction";
const AWAITING_ACTION_ROLES = ["Processor", "QA"];

/**
 * PGS Task List — Admin/AM task management view for Post Grant Support tasks.
 * Filters by workType=Post Grant Support, adds inline status actions,
 * Track Changes modal, and admin edit dialog.
 */
const PGSTaskList = () => {
    useDocumentTitle("Post Grant Support — Tasks");
    const navigate = useNavigate();
    const outerTheme = useTheme();
    const localTheme = React.useMemo(() => createTheme(outerTheme, {
        typography: { fontFamily: 'Lato, sans-serif' },
    }), [outerTheme]);

    const [tasks, setTasks] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [selectedIds, setSelectedIds] = useState([]);
    const [assignDialogOpen, setAssignDialogOpen] = useState(false);
    const [reassignTask, setReassignTask] = useState(null);
    const [workflowUsers, setWorkflowUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasEverLoaded, setHasEverLoaded] = useState(false);
    const [manageUserOpen, setManageUserOpen] = useState(false);
    const [isBulkAssigning, setIsBulkAssigning] = useState(false);
    const fetchCounter = useRef(0);

    // Filter Dropdowns
    const [clients, setClients] = useState([]);
    const [clientFilter, setClientFilter] = useState("All");
    const [supportTypeFilter, setSupportTypeFilter] = useState("All");
    const [statusFilter, setStatusFilter] = useState("All");
    const [priorityFilter, setPriorityFilter] = useState("All"); // COL-135: All | Rush | AwaitingMyAction (COL-157)
    const [mainTab, setMainTab] = useState(1); // COL-144: 0 = Completed, 1 = Pending
    const [groupByFilter, setGroupByFilter] = useState("None");

    // Group By expansion and pagination state
    const [expandedGroups, setExpandedGroups] = useState({});
    const [groupPages, setGroupPages] = useState({});
    const [groupPageSizes, setGroupPageSizes] = useState({});
    const [groupPage, setGroupPage] = useState(0);
    const [groupsPerPage, setGroupsPerPage] = useState(10);

    // Fetch clients list
    useEffect(() => {
        axios_tenant.get(`${BASE_URL}/intake/clients`, { params: { workType: "Post Grant Support" }, silent: true })
            .then(res => setClients(res.data.clients || []))
            .catch(err => console.error("Failed to load clients filter:", err));
    }, []);

    // Reset group-by states when group-by filter changes
    useEffect(() => {
        setExpandedGroups({});
        setGroupPages({});
        setGroupPageSizes({});
        setGroupPage(0);
        setPage(0);
        setTasks([]);
    }, [groupByFilter]);

    // Sorting
    const [sortBy, setSortBy] = useState("deadlineDate"); // COL-138: default sort by Deadline ascending
    const [sortOrder, setSortOrder] = useState("asc");

    const searchFields = React.useMemo(() => {
        if (mainTab === 0) {
            return PGS_SEARCH_FIELDS.filter(f => f.value !== "taskStatus");
        }
        return PGS_SEARCH_FIELDS;
    }, [mainTab]);

    const PGS_PENDING_STATUS_OPTIONS = React.useMemo(() => [
        { value: "",               label: "Select Status..." },
        { value: "To Do",          label: "To Do" },
        { value: "In Progress",    label: "In Progress" },
        { value: "Assign QA",      label: "Assign QA" },
        { value: "QC Pending",     label: "QC Pending" },
        { value: "Under Review",   label: "Under Review" }
    ], []);

    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [debouncedSearchField, setDebouncedSearchField] = useState("all");

    // Snackbar
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const handleSnackbarClose = () => setSnackbar(prev => ({ ...prev, open: false }));

    // User
    const [userRole, setUserRole] = useState(null);
    const [userName, setUserName] = useState("");
    const [userId, setUserId] = useState(null);
    const [oaUserId, setOaUserId] = useState(null);

    // COL-157: Processor and QA land on their own queue. userRole arrives
    // asynchronously, so this cannot be the useState default. It runs on the
    // transition into the Pending tab rather than on every render, leaving the
    // user free to pick another chip afterwards.
    const isAwaitingActionRole = AWAITING_ACTION_ROLES.includes(userRole);
    React.useEffect(() => {
        if (!userRole) return;
        if (isAwaitingActionRole && mainTab === 1) {
            setPriorityFilter(AWAITING_MY_ACTION);
        } else if (mainTab === 0) {
            // The chip is not offered on Completed — every status behind it is
            // a pending one — so leaving it selected would show an empty tab.
            setPriorityFilter(prev => (prev === AWAITING_MY_ACTION ? "All" : prev));
        }
    }, [userRole, isAwaitingActionRole, mainTab]);

    // Staged row assignments state (Processor/QA changes are staged until submit)
    const [rowAssignments, setRowAssignments] = useState({});

    // Track Changes modal
    const [trackChangesTaskId, setTrackChangesTaskId] = useState(null);

    // Actions dropdown menu state
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuTask, setMenuTask] = useState(null);

    // Admin Edit dialog
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [editTask, setEditTask] = useState(null);
    const [editForm, setEditForm] = useState({ applicationNo: "", activityName: "", taskStatus: "", supportType: "", statusOverrideReason: "" });
    const [editSubmitting, setEditSubmitting] = useState(false);
    const [confirmOverrideOpen, setConfirmOverrideOpen] = useState(false);
    const [overrideType, setOverrideType] = useState(""); // "processor" or "qa"

    // Create Task Popups States
    const [createTaskOpen, setCreateTaskOpen] = useState(false);
    const [uploadOpen, setUploadOpen] = useState(false);
    const [manualEntryOpen, setManualEntryOpen] = useState(false);

    // Manual Request Form State (PGS Specific)
    const [manualSupportTypes, setManualSupportTypes] = useState([]);
    const [manualProofreadingScope, setManualProofreadingScope] = useState("Entire");
    const [manualClientCode, setManualClientCode] = useState("");
    const [manualApplicationNumbers, setManualApplicationNumbers] = useState("");
    const [manualSubmitting, setManualSubmitting] = useState(false);

    // Upload Files Dialog State
    const [uploadFiles, setUploadFiles] = useState([]);
    const [uploadClientCode, setUploadClientCode] = useState("");
    const [uploading, setUploading] = useState(false);
    const [uploadResult, setUploadResult] = useState(null);
    const [uploadError, setUploadError] = useState("");
    const [uploadDragOver, setUploadDragOver] = useState(false);
    const uploadFileInputRef = useRef(null);

    const handleCloseUpload = () => {
        setUploadOpen(false);
        setUploadFiles([]);
        setUploadClientCode("");
        setUploading(false);
        setUploadResult(null);
        setUploadError("");
        setUploadDragOver(false);
    };

    const handleCloseManualEntry = () => {
        setManualEntryOpen(false);
        setManualSupportTypes([]);
        setManualProofreadingScope("Entire");
        setManualClientCode("");
        setManualApplicationNumbers("");
        setManualSubmitting(false);
    };

    const handleResetManualEntry = () => {
        setManualSupportTypes([]);
        setManualProofreadingScope("Entire");
        setManualClientCode("");
        setManualApplicationNumbers("");
    };

    const handleSubmitManualEntry = async () => {
        if (!manualApplicationNumbers.trim()) {
            setSnackbar({ open: true, message: "Please enter at least one Application Number", severity: "error" });
            return;
        }
        if (!manualClientCode) {
            setSnackbar({ open: true, message: "Please select a Client", severity: "error" });
            return;
        }
        if (manualSupportTypes.length === 0) {
            setSnackbar({ open: true, message: "Please select at least one Support Type", severity: "error" });
            return;
        }
        if (manualSupportTypes.includes("Proofreading") && !manualProofreadingScope) {
            setSnackbar({ open: true, message: "Please select a Proofreading scope", severity: "error" });
            return;
        }

        let appNumbersArray = [];
        if (manualApplicationNumbers) {
            const normalized = manualApplicationNumbers.replace(/[;\r\n]+/g, "\n");
            const lines = normalized.split("\n");
            for (let line of lines) {
                line = line.trim();
                if (!line) continue;
                const parts = [];
                let currentStart = 0;
                for (let i = 0; i < line.length; i++) {
                    if (line[i] === ',') {
                        const beforeStr = line.substring(0, i).replace(/\s/g, "");
                        const afterStr = line.substring(i + 1).trim();
                        const prefixDigits = line.substring(currentStart, i).replace(/[^0-9]/g, "");
                        const hasDigitBefore = /\d$/.test(beforeStr);
                        const hasThreeDigitsAfter = /^\d{3}(?!\d)/.test(afterStr);
                        const isPrefixValid = prefixDigits.length === 4 || prefixDigits.length === 5;
                        if (hasDigitBefore && hasThreeDigitsAfter && isPrefixValid) {
                            continue;
                        } else {
                            parts.push(line.substring(currentStart, i));
                            currentStart = i + 1;
                        }
                    }
                }
                parts.push(line.substring(currentStart));
                for (let part of parts) {
                    const cleaned = part.replace(/[^0-9]/g, "");
                    if (cleaned) {
                        appNumbersArray.push(cleaned);
                    }
                }
            }
        }

        if (appNumbersArray.length === 0) {
            setSnackbar({ open: true, message: "Please enter at least one valid Application Number", severity: "error" });
            return;
        }

        if (appNumbersArray.length > 500) {
            setSnackbar({ open: true, message: "Maximum 500 application numbers allowed per request", severity: "error" });
            return;
        }

        setManualSubmitting(true);

        try {
            await axios_tenant.post(`${BASE_URL}/request/pgs`, {
                applicationNumbers: appNumbersArray,
                supportTypes: manualSupportTypes,
                proofreadingScope: manualSupportTypes.includes("Proofreading") ? manualProofreadingScope : null,
                clientCode: manualClientCode
            }, {
                headers: { "x-tenant-name": manualClientCode },
                silent: true
            });

            setSnackbar({ open: true, message: "Request created successfully!", severity: "success" });
            handleCloseManualEntry();
            fetchTasks();
        } catch (err) {
            console.error("Manual entry failed:", err);
            setSnackbar({
                open: true,
                message: err?.response?.data?.message || "Failed to create manual entry request",
                severity: "error"
            });
        } finally {
            setManualSubmitting(false);
        }
    };

    // Drag and drop file helper handlers
    const handleDragOver = (e) => { e.preventDefault(); setUploadDragOver(true); };
    const handleDragLeave = () => setUploadDragOver(false);
    const handleDrop = (e) => {
        e.preventDefault();
        setUploadDragOver(false);
        addUploadFiles(Array.from(e.dataTransfer.files));
    };

    const addUploadFiles = (newFiles) => {
        setUploadError("");
        setUploadResult(null);

        const validFiles = newFiles.filter(f => {
            const ext = f.name.split(".").pop().toLowerCase();
            const validExts = ["xlsx", "xls", "csv", "msg"];
            if (!validExts.includes(ext)) {
                setUploadError(`Unsupported file type: .${ext}`);
                return false;
            }
            if (f.size > 25 * 1024 * 1024) {
                setUploadError(`File too large: ${f.name} (max 25MB)`);
                return false;
            }
            return true;
        });

        setUploadFiles(prev => {
            const combined = [...prev, ...validFiles];
            if (combined.length > 10) {
                setUploadError("Maximum 10 files allowed");
                return combined.slice(0, 10);
            }
            return combined;
        });
    };

    const removeUploadFile = (index) => {
        setUploadFiles(prev => prev.filter((_, i) => i !== index));
    };

    const handleUploadFilesSubmit = async () => {
        if (uploadFiles.length === 0) {
            setUploadError("Please select files to upload");
            return;
        }
        if (!uploadClientCode) {
            setUploadError("Please select a client");
            return;
        }

        setUploading(true);
        setUploadError("");
        setUploadResult(null);

        const formData = new FormData();
        uploadFiles.forEach(f => formData.append("files", f));
        formData.append("clientCode", uploadClientCode);

        try {
            const res = await axios_tenant.post(`${BASE_URL}/intake/pgs/upload`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                silent: true
            });
            setUploadResult(res.data.data);
            setUploadFiles([]);
            setSnackbar({ open: true, message: "Files processed successfully!", severity: "success" });
            fetchTasks();
        } catch (err) {
            const msg = err?.response?.data?.message || "Upload failed. Please try again.";
            setUploadError(msg);
            if (err?.response?.data?.data) {
                setUploadResult(err.response.data.data);
            }
        } finally {
            setUploading(false);
        }
    };

    const handleDownloadValidationReport = async (batchId, fileName) => {
        try {
            const response = await axios_tenant.get(`${BASE_URL}/intake/batches/${batchId}/export`, {
                responseType: 'blob',
                silent: true
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Validation_Result_${fileName || `Batch_${batchId}`}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (err) {
            console.error("Failed to download validation report:", err);
            setSnackbar({ open: true, message: "Failed to download validation report.", severity: "error" });
        }
    };

    // Fetch role
    useEffect(() => {
        const controller = new AbortController();
        axios_tenant.get(`${BASE_URL}/me?workType=Post Grant Support`, { signal: controller.signal, silent: true }).then(res => {
            setUserRole(res.data.role);
            setUserName(res.data.displayName || "");
            setUserId(res.data.userId);
            setOaUserId(res.data.oaUserId);
        }).catch((err) => {
            if (err.name === 'AbortError' || err.name === 'CanceledError') return;
            setUserRole("Client");
        });
        return () => controller.abort();
    }, []);

    const fetchTasks = useCallback(async (signal) => {
        if (!userRole) return;
        setLoading(true);
        const currentFetchId = ++fetchCounter.current;

        try {
            const params = {
                page: groupByFilter !== "None" ? 1 : page + 1,
                limit: groupByFilter !== "None" ? 10000 : rowsPerPage,
                sortBy,
                sortOrder,
                workType: "Post Grant Support",
                // COL-144: Completed tab pins status=Completed; Pending tab sends
                // status=Pending (backend maps that to taskStatus != Completed).
                // Sending nothing would return ALL tasks, leaking Completed into Pending.
                ...(mainTab === 0
                    ? { status: "Completed" }
                    : { status: (statusFilter !== "All" && statusFilter !== "Completed") ? statusFilter : "Pending" }),
                ...(clientFilter !== "All" && { routedClient: clientFilter }),
                ...(supportTypeFilter !== "All" && { supportType: supportTypeFilter }),
                // COL-157: "Awaiting My Action" is a status narrowing, not a
                // priority, so it takes the place of the priority param rather
                // than accompanying it. The backend resolves which statuses
                // from the caller's role; we only switch it on.
                ...(priorityFilter === AWAITING_MY_ACTION
                    ? { awaitingMyAction: "true" }
                    : (priorityFilter !== "All" && { priority: priorityFilter })),
                ...(debouncedSearch && debouncedSearchField === "all" && { search: debouncedSearch }),
                ...(debouncedSearch && debouncedSearchField !== "all" && { filterField: debouncedSearchField, filterValue: debouncedSearch }),
                ...(userRole === "Processor" && oaUserId && { processorId: oaUserId }),
                ...(userRole === "QA" && oaUserId && { qaId: oaUserId }),
            };

            const res = await axios_tenant.get(`${BASE_URL}/tasks`, { params, signal, silent: true });
            if (currentFetchId === fetchCounter.current) {
                setTasks(res.data.data || []);
                setTotalRecords(res.data.pagination?.totalRecords || 0);
                setHasEverLoaded(true);
            }
        } catch (err) {
            if (err.name === 'AbortError' || err.name === 'CanceledError') return;
            console.error("Failed to fetch PGS tasks:", err);
            if (currentFetchId === fetchCounter.current) setHasEverLoaded(true);
        } finally {
            if (currentFetchId === fetchCounter.current) setLoading(false);
        }
    }, [page, rowsPerPage, userRole, oaUserId, sortBy, sortOrder, debouncedSearch, debouncedSearchField, clientFilter, supportTypeFilter, statusFilter, priorityFilter, mainTab, groupByFilter]);

    useEffect(() => {
        const controller = new AbortController();
        fetchTasks(controller.signal);
        return () => controller.abort();
    }, [fetchTasks]);

    // Fetch users for assignment
    const fetchUsers = useCallback(async () => {
        if (userRole === "Admin" || userRole === "Application Manager") {
            try {
                const res = await axios_tenant.get(`${BASE_URL}/oashell-users`, {
                    params: { workType: "Post Grant Support" }
                });
                const formattedUsers = (res.data.data || []).map(u => ({
                    id: u.id,
                    email: u.email,
                    displayName: `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.email,
                    role: { roleName: u.roleName, canActAs: u.canActAs || [] },
                    roleId: u.roleId,
                    oaStatus: u.oaStatus
                }));
                setWorkflowUsers(formattedUsers);
            } catch (err) {
                console.error("Failed to fetch workflow users:", err);
            }
        }
    }, [userRole]);

    useEffect(() => { fetchUsers(); }, [fetchUsers]);

    // Handlers

    const handleSortChange = (columnId) => {
        if (sortBy === columnId) {
            setSortOrder(prev => prev === "asc" ? "desc" : "asc");
        } else {
            setSortBy(columnId);
            setSortOrder("asc");
        }
        setPage(0);
    };

    // Bulk assign
    const handleBulkAssign = async ({ processorId, qaId }) => {
        try {
            setIsBulkAssigning(true);
            const body = { taskIds: selectedIds };
            if (processorId) body.processorId = processorId;
            if (qaId) body.qaId = qaId;
            const res = await axios_tenant.post(`${BASE_URL}/tasks/bulk-assign`, body, { silent: true });
            const updatedCount = (res.data.data || []).filter(r => r.status === 'updated').length;
            const skippedCount = (res.data.data || []).filter(r => r.status === 'skipped').length;
            setAssignDialogOpen(false);
            setSelectedIds([]);
            fetchTasks();
            let msg = `${updatedCount} task(s) assigned successfully`;
            if (skippedCount > 0) msg += `, ${skippedCount} skipped`;
            setSnackbar({ open: true, message: msg, severity: skippedCount > 0 ? "warning" : "success" });
        } catch (err) {
            console.error("Bulk assign failed:", err);
            setSnackbar({ open: true, message: err?.response?.data?.message || "Bulk assignment failed", severity: "error" });
        } finally {
            setIsBulkAssigning(false);
        }
    };



    // Admin edit
    const handleOpenEdit = (task) => {
        setEditTask(task);
        let initialActivity = task.activityName || "";
        if (task.supportType === "PTA" || task.supportType === "CoC") {
            initialActivity = task.supportType;
        }
        setEditForm({
            applicationNo: task.applicationNo || "",
            activityName: initialActivity,
            taskStatus: task.taskStatus || "",
            supportType: task.supportType || "",
            statusOverrideReason: ""
        });
        setEditDialogOpen(true);
    };

    const executeSaveEdit = async () => {
        setEditSubmitting(true);
        try {
            await axios_tenant.put(`${BASE_URL}/tasks/${editTask.taskId}/admin-edit`, editForm, { silent: true });
            setSnackbar({ open: true, message: "Task updated successfully", severity: "success" });
            setEditDialogOpen(false);
            setConfirmOverrideOpen(false);
            fetchTasks();
        } catch (err) {
            setSnackbar({ open: true, message: err?.response?.data?.message || "Update failed", severity: "error" });
        } finally {
            setEditSubmitting(false);
        }
    };

    const handleSaveEdit = async () => {
        if (!editTask) return;
        const statusChanged = editForm.taskStatus !== editTask.taskStatus;
        if (statusChanged && !editForm.statusOverrideReason?.trim()) {
            setSnackbar({ open: true, message: "Reason for change is required", severity: "warning" });
            return;
        }

        const isRevertingProcessor = editTask.taskStatus === "In Progress" && editForm.taskStatus === "To Do";
        const isRevertingQA = editTask.taskStatus === "Under Review" && editForm.taskStatus === "QC Pending";

        if (isRevertingProcessor) {
            setOverrideType("processor");
            setConfirmOverrideOpen(true);
        } else if (isRevertingQA) {
            setOverrideType("qa");
            setConfirmOverrideOpen(true);
        } else {
            await executeSaveEdit();
        }
    };

    // Delete
    const handleDeleteTask = async (task) => {
        if (!window.confirm(`Delete task ${task.taskId}? This cannot be undone.`)) return;
        try {
            await axios_tenant.delete(`${BASE_URL}/tasks/${task.taskId}`, { silent: true });
            setSnackbar({ open: true, message: "Task deleted", severity: "success" });
            fetchTasks();
        } catch (err) {
            setSnackbar({ open: true, message: err?.response?.data?.message || "Delete failed", severity: "error" });
        }
    };

    // Bulk Delete selected tasks
    const handleBulkDelete = async () => {
        const selectedTaskObjects = tasks.filter(t => selectedIds.includes(t.taskId));
        const nonCompletedSelected = selectedTaskObjects.filter(t => t.taskStatus !== "Completed");

        if (nonCompletedSelected.length === 0) {
            setSnackbar({ open: true, message: "Only non-completed tasks can be deleted", severity: "warning" });
            return;
        }

        if (!window.confirm(`Are you sure you want to delete ${nonCompletedSelected.length} task(s)? This cannot be undone.`)) {
            return;
        }

        setLoading(true);
        try {
            const taskIdsToDelete = nonCompletedSelected.map(t => t.taskId);
            await axios_tenant.post(`${BASE_URL}/tasks/bulk-delete`, { taskIds: taskIdsToDelete }, { silent: true });
            setSnackbar({
                open: true,
                message: `Deleted ${nonCompletedSelected.length} task(s) successfully.`,
                severity: "success"
            });
        } catch (err) {
            console.error("Failed to delete tasks:", err);
            setSnackbar({
                open: true,
                message: err?.response?.data?.message || "Failed to delete selected task(s)",
                severity: "error"
            });
        } finally {
            setLoading(false);
            setSelectedIds([]);
            fetchTasks();
        }
    };

    // Download PGS Report
    const [reportDialogOpen, setReportDialogOpen] = useState(false);
    const handleDownloadReport = async () => {
        if (selectedIds.length > 0) {
            try {
                setSnackbar({ open: true, message: "Downloading selected tasks report...", severity: "info" });
                const params = {
                    workType: "Post Grant Support",
                    taskIds: selectedIds.join(",")
                };
                const res = await axios_tenant.get(`${BASE_URL}/export-report`, { params, responseType: "blob", silent: true });
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `PGS_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                setSnackbar({ open: true, message: "Report downloaded successfully!", severity: "success" });
            } catch (err) {
                const msg = err?.response?.data?.message || "Failed to download report";
                setSnackbar({ open: true, message: msg, severity: "error" });
            }
        } else {
            setReportDialogOpen(true);
        }
    };

    // ── Inline status change ──
    const [statusChangingTaskId, setStatusChangingTaskId] = useState(null);
    const handleInlineStatusChange = async (taskId, toStatus) => {
        try {
            setStatusChangingTaskId(taskId);
            await axios_tenant.patch(`${BASE_URL}/tasks/${taskId}/status`, { toStatus }, { silent: true });
            setSnackbar({ open: true, message: `Status changed to ${toStatus}`, severity: "success" });
            fetchTasks();
        } catch (err) {
            setSnackbar({ open: true, message: err?.response?.data?.message || "Status change failed", severity: "error" });
        } finally {
            setStatusChangingTaskId(null);
        }
    };

    // ── Rush/Priority toggle (COL-135, AM/Admin only) ──
    const [rushUpdatingId, setRushUpdatingId] = useState(null);
    const handleToggleRush = async (task) => {
        if (rushUpdatingId) return;
        try {
            setRushUpdatingId(task.taskId);
            // Optimistic flip so the pill reacts immediately; refetch reconciles.
            setTasks(prev => prev.map(t => t.taskId === task.taskId ? { ...t, isRush: !t.isRush } : t));
            await axios_tenant.patch(`${BASE_URL}/tasks/${task.taskId}/rush`, { isRush: !task.isRush }, { silent: true });
            setSnackbar({ open: true, message: task.isRush ? "Rush removed" : "Marked as Rush/Priority", severity: "success" });
            await fetchTasks();
        } catch (err) {
            // Roll back the optimistic flip on failure
            setTasks(prev => prev.map(t => t.taskId === task.taskId ? { ...t, isRush: task.isRush } : t));
            setSnackbar({ open: true, message: err?.response?.data?.message || "Failed to update Rush", severity: "error" });
        } finally {
            setRushUpdatingId(null);
        }
    };

    // ── Inline Complexity edit (COL-143, AM/Admin only) ──
    const handleInlineComplexityChange = async (taskId, complexity) => {
        try {
            await axios_tenant.put(`${BASE_URL}/tasks/${taskId}/admin-edit`, { complexity }, { silent: true });
            setSnackbar({ open: true, message: `Complexity set to ${complexity}`, severity: "success" });
            fetchTasks();
        } catch (err) {
            setSnackbar({ open: true, message: err?.response?.data?.message || "Failed to update complexity", severity: "error" });
        }
    };

    // ── Inline Page No. edit (AM/Admin only) ──
    const handleInlinePageNoChange = async (taskId, pageNo) => {
        try {
            await axios_tenant.put(`${BASE_URL}/tasks/${taskId}/admin-edit`, { pageNo }, { silent: true });
            setSnackbar({ open: true, message: `Page No. set to ${pageNo === null ? "—" : pageNo}`, severity: "success" });
            fetchTasks();
        } catch (err) {
            setSnackbar({ open: true, message: err?.response?.data?.message || "Failed to update page number", severity: "error" });
        }
    };

    // ── Inline Deadline edit (Admin/AM, grid) ──
    const handleInlineDeadlineChange = async (taskId, deadlineDate) => {
        try {
            await axios_tenant.put(`${BASE_URL}/tasks/${taskId}/admin-edit`, { deadlineDate }, { silent: true });
            setSnackbar({ open: true, message: "Deadline updated", severity: "success" });
            fetchTasks();
        } catch (err) {
            setSnackbar({ open: true, message: err?.response?.data?.message || "Failed to update deadline", severity: "error" });
            fetchTasks();
        }
    };

    // ── Inline Error / No Error edit (COL-142, Processor/QA/AM/Admin) ──
    const handleInlineErrorChange = async (taskId, errorNoError) => {
        try {
            await axios_tenant.patch(`${BASE_URL}/tasks/${taskId}/error-status`, { errorNoError }, { silent: true });
            setSnackbar({ open: true, message: `Error status set to ${errorNoError}`, severity: "success" });
            fetchTasks();
        } catch (err) {
            setSnackbar({ open: true, message: err?.response?.data?.message || "Failed to update Error / No Error", severity: "error" });
        }
    };

    // ── Inline file upload ──
    const [uploadingTaskId, setUploadingTaskId] = useState(null);
    const handleFileUpload = (taskId) => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".zip,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.png,.jpg,.jpeg";
        input.onchange = async (e) => {
            const file = e.target.files[0];
            if (!file) return;
            const formData = new FormData();
            formData.append("file", file);
            try {
                setUploadingTaskId(taskId);
                await axios_tenant.post(`${BASE_URL}/tasks/${taskId}/pgs-package`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                    silent: true
                });
                setSnackbar({ open: true, message: "File uploaded successfully", severity: "success" });
                fetchTasks();
            } catch (err) {
                setSnackbar({ open: true, message: err?.response?.data?.message || "Upload failed", severity: "error" });
            } finally {
                setUploadingTaskId(null);
            }
        };
        input.click();
    };

    // ── Inline file download ──
    const [downloadingTaskId, setDownloadingTaskId] = useState(null);
    const handleFileDownload = async (taskId, fileName) => {
        try {
            setDownloadingTaskId(taskId);
            const res = await axios_tenant.get(`${BASE_URL}/tasks/${taskId}/package/latest`, { responseType: "blob", silent: true });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName || "package";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            setSnackbar({ open: true, message: "Download failed", severity: "error" });
        } finally {
            setDownloadingTaskId(null);
        }
    };

    // ── File history modal ──
    const [fileHistoryTaskId, setFileHistoryTaskId] = useState(null);
    const [fileHistory, setFileHistory] = useState([]);
    const [fileHistoryLoading, setFileHistoryLoading] = useState(false);
    const [downloadingVersion, setDownloadingVersion] = useState(null);

    const openFileHistory = async (taskId) => {
        setFileHistoryTaskId(taskId);
        setFileHistoryLoading(true);
        try {
            const res = await axios_tenant.get(`${BASE_URL}/tasks/${taskId}/package`);
            setFileHistory(res.data.data || []);
        } catch (err) {
            setFileHistory([]);
        } finally {
            setFileHistoryLoading(false);
        }
    };

    const handleVersionDownload = async (taskId, version, fileName) => {
        try {
            setDownloadingVersion(version);
            const res = await axios_tenant.get(`${BASE_URL}/tasks/${taskId}/package/${version}`, { responseType: "blob", silent: true });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName || `v${version}`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            setSnackbar({ open: true, message: "Download failed", severity: "error" });
        } finally {
            setDownloadingVersion(null);
        }
    };

    // ── Submit button ──
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmTask, setConfirmTask] = useState(null);
    const [submittingTaskId, setSubmittingTaskId] = useState(null);

    const getStagedProcessorId = (task) => {
        const staged = rowAssignments[task.taskId];
        return (staged && staged.processorId !== undefined) ? staged.processorId : task.processorId;
    };

    const getStagedQaId = (task) => {
        const staged = rowAssignments[task.taskId];
        return (staged && staged.qaId !== undefined) ? staged.qaId : task.qaId;
    };

    const getSubmitTarget = (task) => {
        const localProcessorId = getStagedProcessorId(task);
        const localQaId = getStagedQaId(task);
        if (task.canAdminAssign) {
            if (task.taskStatus === 'Assign QA') return 'QC Pending';
            if (localProcessorId === 'SKIP_PROCESSING') return localQaId ? 'QC Pending' : 'Assign QA';
            return 'In Progress';
        }
        return (task.submitTransitions || [])[0] || null;
    };

    const handleSubmitClick = (task) => {
        setConfirmTask(task);
        setConfirmOpen(true);
    };

    const handleConfirmedSubmit = async () => {
        if (!confirmTask) return;

        const localProcessorId = getStagedProcessorId(confirmTask);
        const localQaId = getStagedQaId(confirmTask);
        const submitTarget = getSubmitTarget(confirmTask);

        try {
            setSubmittingTaskId(confirmTask.taskId);
            setConfirmOpen(false);

            if (confirmTask.canAdminAssign) {
                if (confirmTask.taskStatus === 'Assign QA') {
                    // Admin/AM: assign QA from Assign QA → transition to QC Pending
                    if (localQaId && localQaId !== confirmTask.qaId) {
                        await axios_tenant.patch(`${BASE_URL}/tasks/${confirmTask.taskId}/assign`, {
                            qaId: localQaId
                        }, { silent: true });
                    }
                    await axios_tenant.patch(`${BASE_URL}/tasks/${confirmTask.taskId}/status`, { toStatus: 'QC Pending' }, { silent: true });
                    setSnackbar({ open: true, message: "Task assigned and moved to QC Pending", severity: "success" });
                } else if (localProcessorId === 'SKIP_PROCESSING') {
                    // Admin/AM: Skip Processing → clear processor, assign QA, move to QC Pending (or Assign QA)
                    if (localQaId) {
                        await axios_tenant.patch(`${BASE_URL}/tasks/${confirmTask.taskId}/assign`, {
                            processorId: null,
                            qaId: localQaId
                        }, { silent: true });
                        await axios_tenant.patch(`${BASE_URL}/tasks/${confirmTask.taskId}/status`, { toStatus: 'QC Pending' }, { silent: true });
                        setSnackbar({ open: true, message: "Processing skipped — task sent to QA", severity: "success" });
                    } else {
                        await axios_tenant.patch(`${BASE_URL}/tasks/${confirmTask.taskId}/status`, { toStatus: 'Assign QA' }, { silent: true });
                        setSnackbar({ open: true, message: "Processing skipped — task moved to Assign QA", severity: "success" });
                    }
                } else {
                    // Admin/AM: assign Processor/QA from To Do (stays in To Do)
                    await axios_tenant.patch(`${BASE_URL}/tasks/${confirmTask.taskId}/assign`, {
                        processorId: localProcessorId,
                        qaId: localQaId || undefined
                    }, { silent: true });
                    setSnackbar({ open: true, message: "Task assigned successfully", severity: "success" });
                }
            } else {
                // Regular transitions (Processor or QA)
                if (submitTarget === "Completed") {
                    await axios_tenant.post(`${BASE_URL}/tasks/${confirmTask.taskId}/qa-submit`, undefined, { silent: true });
                    setSnackbar({ open: true, message: "Task completed successfully", severity: "success" });
                } else {
                    const res = await axios_tenant.patch(`${BASE_URL}/tasks/${confirmTask.taskId}/status`, { toStatus: submitTarget }, { silent: true });
                    const actualStatus = res.data?.data?.taskStatus;
                    if (actualStatus === "Assign QA" || !confirmTask.qaId) {
                        setSnackbar({ open: true, message: 'Task submitted — moved to "Assign QA"', severity: "success" });
                    } else {
                        setSnackbar({ open: true, message: "Task submitted for QC review", severity: "success" });
                    }
                }
            }

            // Clear staged row assignments for this task
            setRowAssignments(prev => {
                const copy = { ...prev };
                delete copy[confirmTask.taskId];
                return copy;
            });

            fetchTasks();
        } catch (err) {
            setSnackbar({ open: true, message: err?.response?.data?.message || "Submit failed", severity: "error" });
        } finally {
            setSubmittingTaskId(null);
            setConfirmTask(null);
        }
    };

    const selectedTaskObjects = tasks.filter(t => selectedIds.includes(t.taskId));
    const selectedStatuses = new Set(selectedTaskObjects.map(t => t.taskStatus));
    const canAssignProcessor = selectedIds.length > 0 && selectedStatuses.size === 1 && selectedStatuses.has("To Do");
    const canAssignQA = selectedIds.length > 0 && [...selectedStatuses].every(s => ["To Do", "QC Pending", "Assign QA"].includes(s));

    const isAdmin = userRole === "Admin";
    const isAppManager = userRole === "Application Manager" || isAdmin;

    // ── COL-150: AM column customization (selection persists server-side) ──
    const { applyColumnPrefs, isColumnVisible, toggleColumn, resetColumns } = useGridColumnPrefs({
        gridKey: PGS_GRID_KEY,
        mandatoryColumns: PGS_MANDATORY_COLUMNS,
        enabled: isAppManager,
        onSaveError: (message) => setSnackbar({ open: true, message, severity: "warning" })
    });
    const isInternalRole = ["Admin", "Application Manager", "Processor", "QA"].includes(userRole);

    // Role chip color
    const roleColor = {
        "Admin": "#D32F2F",
        "Application Manager": "#1565C0",
        "Processor": "#E65100",
        "QA": "#7B1FA2"
    }[userRole] || "#546E7A";

    // ── Custom renderCell columns ──

    // 0. Inline Complexity Dropdown (COL-143) — editable by AM/Admin, locked once Completed
    const complexityColumn = {
        id: "complexity",
        label: "Complexity",
        minWidth: 110,
        renderCell: (task) => {
            const isCompleted = task.taskStatus === "Completed";
            if (!isAppManager || isCompleted) {
                return <Typography sx={{ fontSize: "13px", color: task.complexity ? "#334155" : "#94A3B8" }}>{task.complexity || "—"}</Typography>;
            }
            return (
                <FormControl size="small" sx={{ minWidth: 110 }}>
                    <Select
                        value={task.complexity || ""}
                        displayEmpty
                        onChange={(e) => {
                            e.stopPropagation();
                            handleInlineComplexityChange(task.taskId, e.target.value);
                        }}
                        onClick={(e) => e.stopPropagation()}
                        sx={{ fontSize: "13px", height: 32, "& .MuiSelect-select": { py: 0.5 } }}
                    >
                        <MenuItem value="" disabled sx={{ fontSize: "13px" }}>Select</MenuItem>
                        <MenuItem value="Simple" sx={{ fontSize: "13px" }}>Simple</MenuItem>
                        <MenuItem value="Complex" sx={{ fontSize: "13px" }}>Complex</MenuItem>
                    </Select>
                </FormControl>
            );
        }
    };

    // 0b. Inline Error / No Error Dropdown (COL-142) — editable by Processor/QA/AM/Admin, locked once Completed
    const errorColumn = {
        id: "errorNoError",
        label: "Error / No Error",
        minWidth: 130,
        renderCell: (task) => {
            const isCompleted = task.taskStatus === "Completed";
            if (!isInternalRole || isCompleted) {
                return <Typography sx={{ fontSize: "13px", color: task.errorNoError ? "#334155" : "#94A3B8" }}>{task.errorNoError || "—"}</Typography>;
            }
            return (
                <FormControl size="small" sx={{ minWidth: 120 }}>
                    <Select
                        value={task.errorNoError || ""}
                        displayEmpty
                        onChange={(e) => {
                            e.stopPropagation();
                            handleInlineErrorChange(task.taskId, e.target.value);
                        }}
                        onClick={(e) => e.stopPropagation()}
                        sx={{ fontSize: "13px", height: 32, "& .MuiSelect-select": { py: 0.5 } }}
                    >
                        <MenuItem value="" disabled sx={{ fontSize: "13px" }}>Select</MenuItem>
                        <MenuItem value="Error" sx={{ fontSize: "13px" }}>Error</MenuItem>
                        <MenuItem value="No Error" sx={{ fontSize: "13px" }}>No Error</MenuItem>
                    </Select>
                </FormControl>
            );
        }
    };

    // 1. Inline Status Dropdown
    const statusColumn = {
        id: "taskStatus",
        label: "Task Status",
        minWidth: 130,
        renderCell: (task) => {
            const dropdownOptions = task.dropdownTransitions || [];
            const isDisabled = dropdownOptions.length === 0;

            return (
                <FormControl size="small" sx={{ minWidth: 130 }}>
                    <Select
                        value={task.taskStatus}
                        disabled={isDisabled}
                        onChange={(e) => {
                            e.stopPropagation();
                            handleInlineStatusChange(task.taskId, e.target.value);
                        }}
                        onClick={(e) => e.stopPropagation()}
                        sx={{ fontSize: "13px", height: 32, "& .MuiSelect-select": { py: 0.5 } }}
                    >
                        <MenuItem value={task.taskStatus} disabled sx={{ fontSize: "13px" }}>
                            {task.taskStatus}
                        </MenuItem>
                        {dropdownOptions.map(opt => (
                            <MenuItem key={opt} value={opt} sx={{ fontSize: "13px" }}>
                                {opt}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            );
        }
    };

    // 2. Attachment Column
    const attachmentColumn = {
        id: "attachment",
        label: "Attachment",
        minWidth: 120,
        renderCell: (task) => {
            const hasFiles = task.packages && task.packages.length > 0;
            const canUpload = canUploadFile(userRole, task.taskStatus, task, oaUserId);
            const isUploading = uploadingTaskId === task.taskId;
            const isDownloading = downloadingTaskId === task.taskId;
            const latestFile = hasFiles ? [...task.packages].sort((a, b) => b.version - a.version)[0] : null;

            return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {canUpload && (
                        <Tooltip title={hasFiles ? "Replace / Upload New" : "Upload File"}>
                            <IconButton
                                size="small"
                                onClick={(e) => { e.stopPropagation(); handleFileUpload(task.taskId); }}
                                disabled={isUploading}
                                sx={{ color: BRAND_COLORS.PRIMARY }}
                            >
                                {isUploading ? <CircularProgress size={18} color="inherit" /> : <AttachFileAddIcon sx={{ fontSize: 18 }} />}
                            </IconButton>
                        </Tooltip>
                    )}
                    {hasFiles && (
                        <>
                            <Tooltip title={`Download: ${latestFile?.fileName || "latest"}`}>
                                <IconButton
                                    size="small"
                                    onClick={(e) => { e.stopPropagation(); handleFileDownload(task.taskId, latestFile?.fileName); }}
                                    disabled={isDownloading}
                                    sx={{ color: BRAND_COLORS.PRIMARY }}
                                >
                                    {isDownloading ? <CircularProgress size={18} color="inherit" /> : <DownloadIcon sx={{ fontSize: 18 }} />}
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="View File History">
                                <IconButton
                                    size="small"
                                    onClick={(e) => { e.stopPropagation(); openFileHistory(task.taskId); }}
                                    sx={{ color: BRAND_COLORS.PRIMARY }}
                                >
                                    <HistoryIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </Tooltip>
                        </>
                    )}
                    {!hasFiles && !canUpload && (
                        <Typography sx={{ fontSize: "14px", color: "#94A3B8" }}>—</Typography>
                    )}
                </Box>
            );
        }
    };

    // 4. Processor Column — inline dropdown for Admin/AM (staged local state)
    const processorColumn = {
        id: "processorName",
        label: "Processor",
        minWidth: 150,
        renderCell: (task) => {
            const isLocked = isProcessorLocked(task.taskStatus);
            const stagedProcId = getStagedProcessorId(task);
            const isSkipProcessing = stagedProcId === "SKIP_PROCESSING";
            const wasProcessingSkipped = !isSkipProcessing && !task.processorId && task.taskStatus !== 'To Do' && task.processorName === 'Processing Skipped';
            
            const displayValue = isSkipProcessing 
                ? "Processing Skipped" 
                : (task.processorName === "Processing Skipped" ? "Processing Skipped" : (task.processorName || "—"));
            
            if (!isAppManager || isLocked) {
                if (task.processorName === "Processing Skipped") {
                    return <Typography sx={{ fontSize: "14px", color: "#6366F1", fontStyle: "italic", fontWeight: 500 }}>{task.processorName}</Typography>;
                }
                return <Typography sx={{ fontSize: "14px", color: "#334155" }}>{displayValue}</Typography>;
            }

            const processors = getEligibleUsers(workflowUsers, "Processor");

            return (
                <FormControl size="small" fullWidth onClick={(e) => e.stopPropagation()}>
                    <Select
                        value={isSkipProcessing ? "SKIP_PROCESSING" : (wasProcessingSkipped ? "PROCESSING_SKIPPED" : (stagedProcId || ""))}
                        onChange={(e) => {
                            const val = e.target.value;
                            setRowAssignments(prev => ({
                                ...prev,
                                [task.taskId]: {
                                    ...(prev[task.taskId] || { processorId: task.processorId, qaId: task.qaId }),
                                    processorId: val === "SKIP_PROCESSING" ? "SKIP_PROCESSING" : (val || null)
                                }
                            }));
                        }}
                        SelectDisplayProps={{
                            style: {
                                padding: "4px 32px 4px 12px",
                                fontSize: "13px",
                                color: (isSkipProcessing || wasProcessingSkipped) ? "#6366F1" : (stagedProcId ? "#334155" : "#94A3B8"),
                                fontStyle: (isSkipProcessing || wasProcessingSkipped) ? "italic" : "normal"
                            }
                        }}
                        onClick={(e) => e.stopPropagation()}
                        sx={{ fontSize: "13px", height: 32 }}
                    >
                        <MenuItem value="">
                            <span style={{ color: "#94A3B8" }}>Unassigned</span>
                        </MenuItem>
                        {wasProcessingSkipped && (
                            <MenuItem value="PROCESSING_SKIPPED" disabled sx={{ fontStyle: 'italic', color: '#6366F1' }}>
                                Processing Skipped
                            </MenuItem>
                        )}
                        {processors.map(p => (
                            <MenuItem key={p.id} value={p.id} sx={{ fontSize: "13px" }}>
                                {p.displayName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            );
        }
    };

    // 5. QA Column — inline dropdown for Admin/AM (staged local state)
    const qaColumn = {
        id: "qaName",
        label: "QA",
        minWidth: 150,
        renderCell: (task) => {
            const isLocked = isQaLocked(task.taskStatus);
            const stagedQaId = getStagedQaId(task);
            // Show "Not Required" for persisted QC-not-required tasks (COL-137)
            const qaValue = stagedQaId || (task.qcRequired === false ? "NOT_REQUIRED" : "");
            const displayValue = task.qcRequired === false ? "Not Required" : (task.qaName || "—");

            if (!isAppManager || isLocked) {
                return <Typography sx={{ fontSize: "14px", color: "#334155", fontStyle: task.qcRequired === false ? "italic" : "normal" }}>{displayValue}</Typography>;
            }

            const qas = getEligibleUsers(workflowUsers, "QA");

            return (
                <FormControl size="small" fullWidth onClick={(e) => e.stopPropagation()}>
                    <Select
                        value={qaValue}
                        onChange={(e) => {
                            const val = e.target.value;
                            setRowAssignments(prev => ({
                                ...prev,
                                [task.taskId]: {
                                    ...(prev[task.taskId] || { processorId: task.processorId, qaId: task.qaId }),
                                    qaId: val || null
                                }
                            }));
                        }}
                        SelectDisplayProps={{
                            style: {
                                padding: "4px 32px 4px 12px",
                                fontSize: "13px",
                                color: qaValue ? "#334155" : "#94A3B8",
                                fontStyle: qaValue === "NOT_REQUIRED" ? "italic" : "normal"
                            }
                        }}
                        onClick={(e) => e.stopPropagation()}
                        sx={{ fontSize: "13px", height: 32 }}
                    >
                        <MenuItem value="">
                            <span style={{ color: "#94A3B8" }}>Unassigned</span>
                        </MenuItem>
                        <MenuItem value="NOT_REQUIRED" sx={{ fontStyle: 'italic', color: '#6366F1' }}>
                            Not Required
                        </MenuItem>
                        {qas.map(q => (
                            <MenuItem key={q.id} value={q.id} sx={{ fontSize: "13px" }}>
                                {q.displayName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            );
        }
    };

    // 3. Actions Column (inline Rush toggle + three-dots menu)
    const actionsColumn = {
        id: "actions",
        label: "Actions",
        minWidth: 125,
        renderCell: (task) => {
            // COL-135: Rush is not applicable once a task is Completed
            const isCompleted = task.taskStatus === "Completed";
            return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {isAppManager && !isCompleted && (
                        <Tooltip title={task.isRush ? "Remove Rush Priority" : "Mark as Rush Priority"}>
                            <Chip
                                icon={rushUpdatingId === task.taskId
                                    ? <CircularProgress size={12} sx={{ color: (task.isRush ? "#fff" : "#DC2626") + " !important", ml: "6px" }} />
                                    : <BoltIcon sx={{ fontSize: "14px !important", color: (task.isRush ? "#fff" : "#DC2626") + " !important" }} />}
                                label="Rush"
                                size="small"
                                disabled={rushUpdatingId === task.taskId}
                                onClick={(e) => { e.stopPropagation(); handleToggleRush(task); }}
                                sx={{
                                    height: 24, fontSize: "11px", fontWeight: 700, cursor: "pointer",
                                    color: task.isRush ? "#fff" : "#DC2626",
                                    backgroundColor: task.isRush ? "#DC2626" : "transparent",
                                    border: `1px solid ${task.isRush ? "#DC2626" : "#FCA5A5"}`,
                                    "&:hover": { backgroundColor: task.isRush ? "#B91C1C" : "#FEE2E2" }
                                }}
                            />
                        </Tooltip>
                    )}
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            setMenuAnchorEl(e.currentTarget);
                            setMenuTask(task);
                        }}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </Box>
            );
        }
    };

    // Frontend group-by tasks computation
    const groupedTasksMap = React.useMemo(() => {
        if (!groupByFilter || groupByFilter === "None") return null;
        const groups = {};
        tasks.forEach(task => {
            let key = "—";
            if (groupByFilter === "Client") {
                const rawClient = task.clientName || task.clientType || task.routedClient || task.tenantCode || "—";
                const foundClient = clients.find(c => c.tenantCode === rawClient);
                key = foundClient ? foundClient.tenantName : rawClient;
            } else if (groupByFilter === "Activity") {
                key = task.activityName || "—";
            } else if (groupByFilter === "Status") {
                key = task.taskStatus || "—";
            } else if (groupByFilter === "Application Number") {
                key = task.applicationNo || "—";
            }
            if (!groups[key]) groups[key] = [];
            groups[key].push(task);
        });
        return groups;
    }, [tasks, groupByFilter, clients]);

    const columns = [
        {
            id: "taskId",
            label: "Task ID",
            minWidth: 160,
            renderCell: (task) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                    <Typography sx={{ fontSize: "14px", color: "#334155" }}>{task.taskId}</Typography>
                    {task.isRush && (
                        <Chip
                            label="RUSH"
                            size="small"
                            icon={<BoltIcon sx={{ fontSize: "14px !important", color: "#DC2626 !important" }} />}
                            sx={{ height: 20, fontSize: "10px", fontWeight: 700, color: "#DC2626", backgroundColor: "#FEE2E2", "& .MuiChip-label": { px: 0.5 } }}
                        />
                    )}
                </Box>
            )
        },
        {
            id: "clientName",
            label: "Client Name",
            minWidth: 150,
            renderCell: (task) => {
                const rawClient = task.clientName || task.clientType || task.routedClient || task.tenantCode || "—";
                const foundClient = clients.find(c => c.tenantCode === rawClient || c.code === rawClient);
                return foundClient ? foundClient.tenantName : rawClient;
            }
        },
        {
            id: "applicationNo",
            label: "Application No.",
            minWidth: 130
        },
        {
            id: "patentNo",
            label: "Patent No.",
            minWidth: 130,
            renderCell: (task) => task.extraFields?.patentNo || "—"
        },
        { id: "activityName", label: "Activity", minWidth: 150 },
        {
            id: "pageNo",
            label: "Page No.",
            minWidth: 110,
            renderCell: (task) => {
                const isCompleted = task.taskStatus === "Completed";
                if (!isAppManager || isCompleted) {
                    return <Typography sx={{ fontSize: "13px", color: task.extraFields?.pageNo != null ? "#334155" : "#94A3B8" }}>{task.extraFields?.pageNo != null ? task.extraFields.pageNo : "—"}</Typography>;
                }
                return (
                    <TextField
                        type="number"
                        defaultValue={task.extraFields?.pageNo ?? ""}
                        size="small"
                        onBlur={(e) => {
                            const val = e.target.value === "" ? null : parseInt(e.target.value, 10);
                            if (val !== task.extraFields?.pageNo) {
                                handleInlinePageNoChange(task.taskId, val);
                            }
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.target.blur();
                            }
                        }}
                        onClick={(e) => e.stopPropagation()}
                        inputProps={{ min: 0, style: { fontSize: "13px", padding: "4px 8px", width: "60px" } }}
                    />
                );
            }
        },
        complexityColumn,
        { id: "requestedDate", label: "Incoming Date", minWidth: 115 },
        {
            id: "deadlineDate",
            label: "Deadline",
            minWidth: 130,
            renderCell: (task) => {
                const isCompleted = task.taskStatus === "Completed";
                const value = task.deadlineDate;
                const readOnly = () => {
                    if (!value) return <Typography sx={{ fontSize: "13px", color: "#94A3B8" }}>—</Typography>;
                    const today = new Date(); today.setHours(0, 0, 0, 0);
                    const dl = new Date(`${String(value).slice(0, 10)}T00:00:00`);
                    const flagged = !isNaN(dl.getTime()) && dl <= today && !isCompleted;
                    const flagLabel = flagged ? (dl < today ? "Overdue" : "Due Today") : null;
                    return (
                        <Typography sx={{ fontSize: "13px", fontWeight: flagged ? 700 : 400, color: flagged ? "#DC2626" : "#334155" }}>
                            {formatDateDDMMMYYYY(value)}
                            {flagLabel && <span style={{ display: "block", fontSize: "11px", fontWeight: 600 }}>{flagLabel}</span>}
                        </Typography>
                    );
                };
                if (!isAppManager || isCompleted) return readOnly();
                const incomingDate = String(task.requestedDate || "").slice(0, 10);
                return (
                    <TextField
                        type="date"
                        size="small"
                        // Uncontrolled input: re-key on the value so a refetch
                        // (e.g. after toggling Rush) shows the new deadline.
                        key={`deadline-${task.taskId}-${value || ""}`}
                        defaultValue={value ? String(value).slice(0, 10) : ""}
                        inputProps={{ min: incomingDate || undefined, style: { fontSize: "13px", padding: "4px 8px" } }}
                        onBlur={(e) => {
                            const v = e.target.value;
                            const current = value ? String(value).slice(0, 10) : "";
                            if (!v || v === current) return;
                            if (incomingDate && v < incomingDate) {
                                setSnackbar({ open: true, message: "Deadline Date cannot be earlier than the Incoming Date", severity: "error" });
                                e.target.value = current;
                                return;
                            }
                            handleInlineDeadlineChange(task.taskId, v);
                        }}
                        onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); }}
                        onClick={(e) => e.stopPropagation()}
                    />
                );
            }
        },
        { id: "sourceFile", label: "Source File", minWidth: 140 },
        statusColumn,
        errorColumn,
        processorColumn,
        qaColumn,
        { id: "createdAt", label: "Created Date & Time", minWidth: 150 },
        {
            id: "createdBy",
            label: "Created By",
            minWidth: 130,
            renderCell: (task) => {
                if (!task.createdBy) return "—";
                return task.createdBy.replace(/\s*\([^)]+\)$/, "");
            }
        },
        actionsColumn
    ];

    return (
        <ThemeProvider theme={localTheme}>
            <Box className="oa-lato-font" sx={{ height: "calc(100vh - 150px)", display: "flex", flexDirection: "column", overflow: "hidden", pt: 0, mt: -3, px: 4, pb: 1 }} data-testid="pgs-task-list-page">
                
                {/* Header Wrapper (contains Title, Search, Actions, and Filters) */}
                <Box sx={{
                    bgcolor: "#f3f8fc",
                    pt: 1,
                    pb: 1,
                    mb: 1
                }}>
                    {/* Header */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            <Typography variant="h5" sx={{ color: "#0F172A", fontSize: "22px", fontWeight: 600 }}>
                                Post Grant Support
                            </Typography>
                            {userRole && (
                                <Box sx={{
                                    backgroundColor: "#F1F5F9", border: "1px solid #E2E8F0",
                                    borderRadius: "50px", px: 2, py: 0.5
                                }}>
                                    <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#475569" }}>
                                        {userRole} - {userName}
                                    </Typography>
                                </Box>
                            )}
                            {/* COL-135: Rush count on the current view */}
                            {tasks.some(t => t.isRush) && (
                                <Chip
                                    icon={<BoltIcon sx={{ fontSize: "16px !important", color: "#DC2626 !important" }} />}
                                    label={`${tasks.filter(t => t.isRush).length} Rush`}
                                    size="small"
                                    sx={{ fontWeight: 700, fontSize: "12px", color: "#DC2626", backgroundColor: "#FEE2E2" }}
                                />
                            )}
                        </Box>
                        
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                            <Button
                                variant="secondary"
                                onClick={handleDownloadReport}
                                startIcon={<DownloadIcon sx={{ fontSize: 18 }} />}
                                sx={{ height: 36, fontWeight: 500, borderRadius: "6px", textTransform: "none" }}
                            >
                                Download Report
                            </Button>

                            {/* COL-150: AM-only column picker; selection persists server-side */}
                            {isAppManager && (
                                <ColumnPickerMenu
                                    columns={columns}
                                    mandatoryColumns={PGS_MANDATORY_COLUMNS}
                                    isColumnVisible={isColumnVisible}
                                    onToggle={toggleColumn}
                                    onReset={resetColumns}
                                    testId="pgs-column-picker-btn"
                                />
                            )}

                            {isAppManager && (
                                <Button
                                    variant="secondary"
                                    onClick={() => setManageUserOpen(true)}
                                    startIcon={<AddIcon sx={{ fontSize: 18 }} />}
                                    sx={{ height: 36, fontWeight: 500, borderRadius: "6px", textTransform: "none" }}
                                >
                                    Manage User
                                </Button>
                            )}

                            <Tooltip title="Refresh">
                                <IconButton
                                    onClick={() => fetchTasks()}
                                    size="small"
                                    sx={{
                                        border: `1px solid ${BRAND_COLORS.PRIMARY}`, borderRadius: "6px",
                                        width: 36, height: 36, backgroundColor: "#fff", color: BRAND_COLORS.PRIMARY,
                                        "&:hover": { backgroundColor: BRAND_COLORS.SECONDARY_HOVER }
                                    }}
                                >
                                    <SyncIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </Tooltip>

                            {isAppManager && (
                                <Tooltip title="Create Task / Upload Files">
                                    <IconButton
                                        onClick={() => setCreateTaskOpen(true)}
                                        sx={{
                                            backgroundColor: BRAND_COLORS.PRIMARY, color: "#fff", borderRadius: "6px",
                                            width: 36, height: 36, "&:hover": { backgroundColor: BRAND_COLORS.PRIMARY_HOVER }
                                        }}
                                    >
                                        <AddIcon sx={{ fontSize: 20 }} />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Box>
                    </Box>

                    {/* COL-144: Pending / Completed tabs */}
                    <Tabs
                        value={mainTab}
                        onChange={(e, v) => {
                            setMainTab(v);
                            setPage(0);
                            setSelectedIds([]);
                            if (debouncedSearchField === "taskStatus") {
                                setDebouncedSearch("");
                                setDebouncedSearchField("all");
                            }
                        }}
                        sx={{ ...TAB_STYLES, mb: 2.5, minHeight: 40, "& .MuiTab-root": { textTransform: "none", minHeight: 40, fontWeight: 600 } }}
                    >
                        {/* COL-147: Pending is the working queue, so it comes first.
                            Explicit values keep the existing 0 = Completed / 1 = Pending
                            semantics used by fetchTasks and the status filter. */}
                        <Tab label="Pending" value={1} />
                        <Tab label="Completed" value={0} />
                    </Tabs>

                    {/* Search and Secondary Controls Row */}
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
                        {/* Search Bar on the left */}
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                            <OASearchBar
                                fields={searchFields}
                                onSearch={(value, field) => {
                                    setDebouncedSearch(value);
                                    setDebouncedSearchField(field);
                                    setPage(0);
                                }}
                                clients={clients}
                                statusOptions={mainTab === 1 ? PGS_PENDING_STATUS_OPTIONS : undefined}
                            />
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, pl: 0.5 }}>
                                {/* COL-157: All / Rush, plus "Awaiting My Action" for Processor
                                    and QA on the Pending tab — its statuses are all pending
                                    ones, so it would return nothing on Completed. The
                                    Standard chip was removed; All covers it. */}
                                {[
                                    { key: "All", label: "All", icon: null },
                                    { key: "Rush", label: "Rush", icon: <BoltIcon sx={{ fontSize: "14px !important" }} /> },
                                    ...(isAwaitingActionRole && mainTab === 1
                                        ? [{ key: AWAITING_MY_ACTION, label: "Awaiting My Action", icon: null }]
                                        : [])
                                ].map(opt => (
                                    <Chip
                                        key={opt.key}
                                        label={opt.label}
                                        icon={opt.icon || undefined}
                                        size="small"
                                        onClick={() => { setPriorityFilter(opt.key); setPage(0); }}
                                        variant={priorityFilter === opt.key ? "filled" : "outlined"}
                                        sx={{
                                            fontSize: "12px", fontWeight: 600,
                                            ...(priorityFilter === opt.key
                                                ? (opt.key === "Rush"
                                                    ? { backgroundColor: "#DC2626", color: "#fff", "& .MuiChip-icon": { color: "#fff !important" }, "&:hover": { backgroundColor: "#B91C1C" } }
                                                    : { backgroundColor: BRAND_COLORS.PRIMARY, color: "#fff", "&:hover": { backgroundColor: BRAND_COLORS.PRIMARY_HOVER } })
                                                : (opt.key === "Rush"
                                                    ? { color: "#DC2626", borderColor: "#FCA5A5", "& .MuiChip-icon": { color: "#DC2626 !important" }, "&:hover": { backgroundColor: "#FEE2E2" } }
                                                    : { color: BRAND_COLORS.PRIMARY, borderColor: BRAND_COLORS.PRIMARY, "&:hover": { backgroundColor: BRAND_COLORS.SECONDARY_HOVER } }))
                                        }}
                                    />
                                ))}
                                <Typography sx={{ fontSize: "12px", color: "#64748B", ml: 1, fontWeight: 500 }}>
                                    Only the last 30 days of task history are available.
                                </Typography>
                            </Box>
                        </Box>

                        {/* Right side: Group By OR Bulk Actions */}
                        <Box>
                            {selectedIds.length === 0 ? (
                                <FormControl size="small" sx={{ minWidth: 140 }}>
                                    <InputLabel>Group By</InputLabel>
                                    <Select
                                        value={groupByFilter}
                                        label="Group By"
                                        onChange={(e) => setGroupByFilter(e.target.value)}
                                        sx={{ backgroundColor: "#fff", borderRadius: "6px" }}
                                    >
                                        <MenuItem value="None">None</MenuItem>
                                        <MenuItem value="Client">Client</MenuItem>
                                        <MenuItem value="Activity">Activity</MenuItem>
                                        <MenuItem value="Status">Status</MenuItem>
                                        <MenuItem value="Application Number">Application Number</MenuItem>
                                    </Select>
                                </FormControl>
                            ) : (
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                    {/* Selected Count Badge */}
                                    <Box sx={{
                                        border: "1px solid #3B82F6",
                                        backgroundColor: "#EFF6FF",
                                        color: "#1D4ED8",
                                        borderRadius: "50px",
                                        px: 1.5,
                                        py: 0.5,
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        display: "flex",
                                        alignItems: "center"
                                    }}>
                                        {selectedIds.length} Selected
                                    </Box>
                                    
                                    <Typography sx={{ fontSize: "13px", color: "#64748B", fontWeight: 500 }}>
                                        Actions applied to selected items
                                    </Typography>

                                    {isAppManager && (
                                        <Button
                                            variant="secondary"
                                            onClick={() => setAssignDialogOpen(true)}
                                            disabled={(!canAssignProcessor && !canAssignQA)}
                                            sx={{
                                                height: 32,
                                                fontWeight: 500,
                                                borderRadius: "6px",
                                                textTransform: "none",
                                                border: `1px solid ${BRAND_COLORS.PRIMARY}`,
                                                color: BRAND_COLORS.PRIMARY,
                                                backgroundColor: "#fff",
                                                "&:hover": {
                                                    backgroundColor: BRAND_COLORS.SECONDARY_HOVER
                                                }
                                            }}
                                        >
                                            Assign
                                        </Button>
                                    )}

                                    {isAppManager && (
                                        <Button
                                            variant="secondary"
                                            onClick={handleBulkDelete}
                                            sx={{
                                                height: 32,
                                                fontWeight: 500,
                                                borderRadius: "6px",
                                                textTransform: "none",
                                                border: "1px solid #EF4444",
                                                color: "#EF4444",
                                                backgroundColor: "#fff",
                                                "&:hover": {
                                                    backgroundColor: "#FEF2F2"
                                                }
                                            }}
                                        >
                                            Delete
                                        </Button>
                                    )}
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Box>

                {/* Task Table */}
                <Box sx={{ position: "relative", flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
                    {loading && !hasEverLoaded ? (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
                            <CircularProgress size={32} sx={{ color: BRAND_COLORS.PRIMARY }} />
                        </Box>
                    ) : (
                        <Box sx={{ position: "relative", flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
                            {loading && (
                                <Box sx={{
                                    position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
                                    backgroundColor: "rgba(255,255,255,0.6)",
                                    zIndex: 10, display: "flex", justifyContent: "center", alignItems: "center",
                                    minHeight: 200
                                }}>
                                    <CircularProgress size={32} sx={{ color: BRAND_COLORS.PRIMARY }} />
                                </Box>
                            )}

                            {groupByFilter !== "None" && groupedTasksMap ? (
                                <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, flex: 1, overflowY: "auto", pr: 1 }}>
                                        {Object.entries(groupedTasksMap)
                                            .slice(groupPage * groupsPerPage, (groupPage + 1) * groupsPerPage)
                                            .map(([groupName, groupTasks]) => {
                                                const isExpanded = !!expandedGroups[groupName];
                                                const currentPage = groupPages[groupName] || 0;
                                                const pageSize = groupPageSizes[groupName] || 10;
                                                const paginatedTasks = groupTasks.slice(currentPage * pageSize, (currentPage + 1) * pageSize);

                                                return (
                                                    <Box key={groupName} sx={{ display: "flex", flexDirection: "column" }}>
                                                        <Box
                                                            onClick={() => setExpandedGroups(prev => ({ ...prev, [groupName]: !prev[groupName] }))}
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                                fontWeight: 600,
                                                                fontSize: "14px",
                                                                color: "#475569",
                                                                backgroundColor: "#F1F5F9",
                                                                px: 2,
                                                                py: 1.5,
                                                                borderRadius: isExpanded ? "6px 6px 0 0" : "6px",
                                                                border: "1px solid #E2E8F0",
                                                                cursor: "pointer",
                                                                userSelect: "none",
                                                                "&:hover": {
                                                                    backgroundColor: "#E2E8F0"
                                                                }
                                                            }}
                                                        >
                                                            <Typography sx={{ fontWeight: 600, fontSize: "14px", color: "#475569" }}>
                                                                {groupByFilter}: {groupName} ({groupTasks.length} {groupTasks.length === 1 ? "task" : "tasks"})
                                                            </Typography>
                                                            {isExpanded ? <ExpandLessIcon sx={{ fontSize: 20, color: "#64748B" }} /> : <ExpandMoreIcon sx={{ fontSize: 20, color: "#64748B" }} />}
                                                        </Box>
                                                        {isExpanded && (
                                                            <TaskTable
                                                                tasks={paginatedTasks}
                                                                totalRecords={groupTasks.length}
                                                                page={currentPage}
                                                                rowsPerPage={pageSize}
                                                                columns={applyColumnPrefs(columns)}
                                                                selectable={isAppManager}
                                                                selectedIds={selectedIds}
                                                                onSelect={setSelectedIds}
                                                                sortBy={sortBy}
                                                                sortOrder={sortOrder}
                                                                onSortChange={handleSortChange}
                                                                onPageChange={(newPage) => setGroupPages(prev => ({ ...prev, [groupName]: newPage }))}
                                                                onRowsPerPageChange={(newSize) => {
                                                                    setGroupPageSizes(prev => ({ ...prev, [groupName]: newSize }));
                                                                    setGroupPages(prev => ({ ...prev, [groupName]: 0 }));
                                                                }}
                                                                enableLink={false}
                                                                highlightRow={(t) => t.isRush}
                                                            />
                                                        )}
                                                    </Box>
                                                );
                                            })
                                        }
                                    </Box>
                                    {Object.keys(groupedTasksMap).length > groupsPerPage && (
                                        <OAPagination
                                            count={Object.keys(groupedTasksMap).length}
                                            page={groupPage}
                                            rowsPerPage={groupsPerPage}
                                            onPageChange={(newPage) => setGroupPage(newPage)}
                                            onRowsPerPageChange={(newSize) => {
                                                setGroupsPerPage(newSize);
                                                setGroupPage(0);
                                            }}
                                            label="Groups per page:"
                                        />
                                    )}
                                </Box>
                            ) : (
                                <TaskTable
                                    tasks={groupByFilter === "None" ? tasks.slice(0, rowsPerPage) : tasks}
                                    totalRecords={totalRecords}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    loading={loading}
                                    onPageChange={setPage}
                                    onRowsPerPageChange={(val) => { setRowsPerPage(val); setPage(0); }}
                                    selectable={isAppManager}
                                    selectedIds={selectedIds}
                                    onSelect={setSelectedIds}
                                    columns={applyColumnPrefs(columns)}
                                    sortBy={sortBy}
                                    sortOrder={sortOrder}
                                    onSortChange={handleSortChange}
                                    enableLink={true}
                                    onTaskClick={(id) => navigate(`/collaboration-space/pgs-workflow/tasks/${id}`)}
                                    highlightRow={(t) => t.isRush}
                                />
                            )}
                        </Box>
                    )}
                </Box>

                {/* Dialogs */}
                <AssignDialog
                    open={assignDialogOpen}
                    onClose={() => setAssignDialogOpen(false)}
                    onAssign={handleBulkAssign}
                    isAssigning={isBulkAssigning}
                    selectedTasks={selectedTaskObjects}
                    onRemoveTask={(id) => setSelectedIds(prev => prev.filter(i => i !== id))}
                    users={workflowUsers}
                    enableProcessor={canAssignProcessor}
                    enableQA={canAssignQA}
                />

                <UpdateAssignmentModal
                    open={!!reassignTask}
                    onClose={() => setReassignTask(null)}
                    task={reassignTask}
                    users={workflowUsers}
                    onUpdateSuccess={fetchTasks}
                />

                <ManageUserModal
                    open={manageUserOpen}
                    onClose={() => setManageUserOpen(false)}
                    onUsersChanged={fetchUsers}
                    workType="Post Grant Support"
                />

                <TrackChangesModal
                    open={!!trackChangesTaskId}
                    onClose={() => setTrackChangesTaskId(null)}
                    taskId={trackChangesTaskId}
                />

                {/* --- DOWNLOAD REPORT DIALOG --- */}
                <DownloadReportModal
                    open={reportDialogOpen}
                    onClose={() => setReportDialogOpen(false)}
                    workType="Post Grant Support"
                    supportTypeFilter={supportTypeFilter}
                    clientFilter={clientFilter}
                    onSuccess={(msg) => setSnackbar({ open: true, message: msg, severity: "success" })}
                    onError={(msg) => setSnackbar({ open: true, message: msg, severity: "error" })}
                />

                {/* --- 1. CREATE TASK SELECTION DIALOG --- */}
                <Dialog
                    open={createTaskOpen}
                    onClose={() => setCreateTaskOpen(false)}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{ sx: { borderRadius: "12px", p: 1 } }}
                >
                    <DialogTitle sx={{ pb: 0, fontWeight: 700, fontSize: "20px", color: "#1E293B" }}>
                        Create Task
                    </DialogTitle>
                    <DialogContent sx={{ pt: 1 }}>
                        <Typography sx={{ color: "#64748B", fontSize: "14px", mb: 3 }}>
                            Choose how you want to create workflow tasks.
                        </Typography>

                        <Box sx={{ display: "flex", gap: 3, flexWrap: { xs: "wrap", md: "nowrap" }, mt: 2 }}>
                            {/* Card 1: Upload / Import */}
                            <Box
                                onClick={() => {
                                    setCreateTaskOpen(false);
                                    setUploadOpen(true);
                                }}
                                sx={{
                                    flex: 1,
                                    border: "1px solid #E2E8F0",
                                    borderRadius: "10px",
                                    p: 3,
                                    cursor: "pointer",
                                    transition: "all 0.2s ease-in-out",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: 1.5,
                                    "&:hover": {
                                        borderColor: BRAND_COLORS.PRIMARY,
                                        backgroundColor: "#F8FAFC",
                                        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)"
                                    }
                                }}
                            >
                                <Box sx={{
                                    width: 44, height: 44, borderRadius: "8px",
                                    backgroundColor: "#E6F4FD", display: "flex",
                                    alignItems: "center", justifyContent: "center", color: BRAND_COLORS.PRIMARY
                                }}>
                                    <CloudUploadOutlinedIcon sx={{ fontSize: 22 }} />
                                </Box>
                                <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#0F172A" }}>
                                    Upload / Import Files
                                </Typography>
                                <Typography sx={{ fontSize: "12px", color: "#64748B", lineHeight: 1.5 }}>
                                    Drag and drop Outlook, Excel, CSV, or PDF files and let the system extract task details.
                                </Typography>
                            </Box>

                            {/* Card 2: Manual Entry */}
                            <Box
                                onClick={() => {
                                    setCreateTaskOpen(false);
                                    setManualEntryOpen(true);
                                }}
                                sx={{
                                    flex: 1,
                                    border: "1px solid #E2E8F0",
                                    borderRadius: "10px",
                                    p: 3,
                                    cursor: "pointer",
                                    transition: "all 0.2s ease-in-out",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: 1.5,
                                    "&:hover": {
                                        borderColor: BRAND_COLORS.PRIMARY,
                                        backgroundColor: "#F8FAFC",
                                        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)"
                                    }
                                }}
                            >
                                <Box sx={{
                                    width: 44, height: 44, borderRadius: "8px",
                                    backgroundColor: "#E6F4FD", display: "flex",
                                    alignItems: "center", justifyContent: "center", color: BRAND_COLORS.PRIMARY
                                }}>
                                    <EditOutlinedIcon sx={{ fontSize: 22 }} />
                                </Box>
                                <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#0F172A" }}>
                                    Manual Entry
                                </Typography>
                                <Typography sx={{ fontSize: "12px", color: "#64748B", lineHeight: 1.5 }}>
                                    Manually select client, request type, support type, and enter Application/Patent No.
                                </Typography>
                            </Box>
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: "flex-end", px: 3, py: 2, borderTop: "1px solid #E2E8F0" }}>
                        <Button variant="secondary" onClick={() => setCreateTaskOpen(false)}>
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* --- 2. UPLOAD / IMPORT FILES DIALOG --- */}
                <Dialog
                    open={uploadOpen}
                    onClose={handleCloseUpload}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{ sx: { borderRadius: "12px" } }}
                >
                    <DialogTitle sx={{ fontWeight: 700, fontSize: "18px", borderBottom: "1px solid #E2E8F0", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>Upload / Import Files — Post Grant Support</span>
                        <IconButton size="small" onClick={handleCloseUpload} sx={{ color: "#94A3B8" }}>
                            <CloseIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent sx={{ pt: "20px !important", pb: 3 }}>
                        <Box>
                            <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                                <InputLabel id="pgs-upload-client-label">Select Client</InputLabel>
                                <Select
                                    labelId="pgs-upload-client-label"
                                    value={uploadClientCode}
                                    label="Select Client"
                                    onChange={(e) => { setUploadClientCode(e.target.value); setUploadError(""); }}
                                    sx={{ backgroundColor: "#fff" }}
                                >
                                    {clients.map(c => (
                                        <MenuItem key={c.tenantCode || c.code} value={c.tenantCode || c.code}>
                                            {c.tenantName ? `${c.tenantName} (${c.tenantCode || c.code})` : (c.clientName || c.name || c.tenantCode || c.code)}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <Box
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}
                                onClick={() => uploadFileInputRef.current?.click()}
                                sx={{
                                    border: `2px dashed ${uploadDragOver ? BRAND_COLORS.PRIMARY : "#CBD5E1"}`,
                                    borderRadius: "8px",
                                    backgroundColor: uploadDragOver ? "#EAF2FF" : "#F8FAFC",
                                    p: 4,
                                    textAlign: "center",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    mb: 3,
                                    "&:hover": {
                                        borderColor: BRAND_COLORS.PRIMARY,
                                        backgroundColor: "#F2F7FC"
                                    }
                                }}
                            >
                                <CloudUploadOutlinedIcon sx={{ fontSize: 40, color: BRAND_COLORS.PRIMARY, mb: 1 }} />
                                <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#334155", mb: 0.5 }}>
                                    Drag & drop files here, or click to browse
                                </Typography>
                                <Typography sx={{ fontSize: "12px", color: "#94A3B8" }}>
                                    Supports .xlsx, .xls, .csv, .msg — up to 10 files, 25MB each
                                </Typography>
                                <input
                                    ref={uploadFileInputRef}
                                    type="file"
                                    multiple
                                    accept=".xlsx,.xls,.csv,.msg"
                                    onChange={(e) => addUploadFiles(Array.from(e.target.files))}
                                    style={{ display: "none" }}
                                />
                            </Box>

                            {uploadFiles.length > 0 && (
                                <Box sx={{ mb: 3 }}>
                                    <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#475569", mb: 1 }}>
                                        {uploadFiles.length} file{uploadFiles.length !== 1 ? "s" : ""} selected
                                    </Typography>
                                    {uploadFiles.map((f, idx) => (
                                        <Box key={idx} sx={{
                                            display: "flex", alignItems: "center", gap: 1.5,
                                            backgroundColor: "#fff", border: "1px solid #E2E8F0",
                                            borderRadius: "6px", p: 1, mb: 1
                                        }}>
                                            <DescriptionOutlinedIcon sx={{ color: "#64748B", fontSize: 18 }} />
                                            <Box sx={{ flex: 1 }}>
                                                <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#1E293B" }}>
                                                    {f.name}
                                                </Typography>
                                            </Box>
                                            {uploading ? (
                                                <Chip
                                                    label="Pending"
                                                    size="small"
                                                    sx={{ height: 20, fontSize: "9px", fontWeight: 600, bgcolor: "#FEF3C7", color: "#D97706" }}
                                                />
                                            ) : (
                                                <>
                                                    <Chip
                                                        label={f.name.split(".").pop().toUpperCase()}
                                                        size="small"
                                                        sx={{ height: 20, fontSize: "9px", fontWeight: 600, bgcolor: "#F1F5F9" }}
                                                    />
                                                    <CloseIcon
                                                        sx={{ fontSize: 16, color: "#94A3B8", cursor: "pointer", "&:hover": { color: "#EF4444" } }}
                                                        onClick={(e) => { e.stopPropagation(); removeUploadFile(idx); }}
                                                    />
                                                </>
                                            )}
                                        </Box>
                                    ))}
                                </Box>
                            )}

                            {uploadError && (
                                <Alert severity="error" sx={{ mb: 2, borderRadius: "6px" }}>
                                    {uploadError}
                                </Alert>
                            )}

                            {uploadResult && (
                                <Box sx={{
                                    backgroundColor: "#F8FAFC", border: "1px solid #E2E8F0",
                                    borderRadius: "8px", p: 2, mb: 2
                                }}>
                                    <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1E293B", mb: 1.5 }}>
                                        Upload Results
                                    </Typography>
                                    <Box sx={{ display: "flex", gap: 1.5, mb: 2, flexWrap: 'wrap' }}>
                                        <Chip
                                            icon={<CheckCircleOutlineIcon sx={{ fontSize: '16px !important' }} />}
                                            label={`${uploadResult.summary?.totalTasksCreated || 0} tasks created`}
                                            color="success" variant="outlined" size="small"
                                        />
                                        <Chip
                                            label={`${uploadResult.summary?.successFiles || 0}/${uploadResult.summary?.totalFiles || 0} files successfully processed`}
                                            color="info" variant="outlined" size="small"
                                        />
                                    </Box>
                                    {uploadResult.files?.map((f, idx) => {
                                        const isPass = f.status === "success";
                                        const isPartial = isPass && ((f.duplicates || 0) + (f.skipped || 0) > 0);
                                        const chipLabel = isPartial ? "Partial" : (isPass ? "Pass" : "Failed");
                                        const chipBg = isPartial ? "#FFF3E0" : (isPass ? "#DCFCE7" : "#FEE2E2");
                                        const chipColor = isPartial ? "#E65100" : (isPass ? "#16A34A" : "#EF4444");
                                        const hasValidationReport = f.batchId && (f.status === "failed" || f.duplicates > 0 || f.skipped > 0 || (isPass && f.created === 0));
                                        return (
                                            <Box key={idx} sx={{
                                                display: "flex", alignItems: "center", gap: 1.5, py: 1,
                                                borderTop: idx > 0 ? "1px solid #E2E8F0" : "none"
                                            }}>
                                                <Chip
                                                    label={chipLabel}
                                                    size="small"
                                                    sx={{
                                                        height: 20,
                                                        fontSize: "10px",
                                                        fontWeight: 700,
                                                        bgcolor: chipBg,
                                                        color: chipColor
                                                    }}
                                                />
                                                <Typography sx={{ fontSize: "12px", color: "#334155", flex: 1, fontWeight: 500 }}>
                                                    {f.fileName}
                                                    {isPass && f.created === 0 && (
                                                        <span style={{ color: "#64748B", fontWeight: 400, marginLeft: "8px" }}>
                                                            (all duplicate/skipped)
                                                        </span>
                                                    )}
                                                </Typography>
                                                <Typography sx={{ fontSize: "11px", color: isPass ? "#16A34A" : "#EF4444", fontWeight: 600, mr: hasValidationReport ? 1 : 0 }}>
                                                    {isPass ? `${f.created || 0} task(s) created` : (f.reason || "Could not detect required details")}
                                                </Typography>
                                                {hasValidationReport && (
                                                    <Tooltip title="Download Validation Report">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleDownloadValidationReport(f.batchId, f.fileName)}
                                                            sx={{ color: "#005CB9", p: 0.5 }}
                                                        >
                                                            <DownloadIcon sx={{ fontSize: "18px" }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </Box>
                                        );
                                    })}
                                </Box>
                            )}

                            <Button
                                variant="primary"
                                onClick={handleUploadFilesSubmit}
                                disabled={uploading || uploadFiles.length === 0 || !uploadClientCode}
                                sx={{ width: "100%", height: 38, fontSize: "14px", fontWeight: 600 }}
                            >
                                {uploading ? (
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: 'center' }}>
                                        <CircularProgress size={16} color="inherit" />
                                        Processing...
                                    </Box>
                                ) : (
                                    `Upload ${uploadFiles.length > 0 ? `${uploadFiles.length} file${uploadFiles.length !== 1 ? "s" : ""}` : ""}`
                                )}
                            </Button>
                            {uploading && <LinearProgress sx={{ mt: 2, borderRadius: 1 }} />}
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #E2E8F0" }}>
                        <Button variant="secondary" onClick={handleCloseUpload}>
                            {uploadResult ? "OK" : "Close"}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* --- 3. MANUAL ENTRY "NEW REQUEST" DIALOG (FIGMA COMPLIANT) --- */}
                <Dialog
                    open={manualEntryOpen}
                    onClose={handleCloseManualEntry}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{ sx: { borderRadius: "12px" } }}
                >
                    <DialogTitle sx={{ fontWeight: 700, fontSize: "18px", borderBottom: "1px solid #E2E8F0" }}>
                        New Request
                    </DialogTitle>
                    <DialogContent sx={{ pt: "20px !important", pb: 3 }}>
                        {/* 1. Select Support Type */}
                        <Box sx={{ mb: 3 }}>
                            <Typography sx={{ fontWeight: 700, fontSize: "13px", color: "#334155", mb: 0.5 }}>
                                Select Support Type
                            </Typography>
                            <Typography sx={{ fontSize: "11px", color: "#94A3B8", mb: 1.5 }}>
                                Multiple options can be selected
                            </Typography>

                            <FormGroup row sx={{ gap: 2 }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={manualSupportTypes.includes("Proofreading")}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setManualSupportTypes(prev => [...prev, "Proofreading"]);
                                                } else {
                                                    setManualSupportTypes(prev => prev.filter(t => t !== "Proofreading"));
                                                }
                                            }}
                                        />
                                    }
                                    label={<span style={{ fontSize: "13px", fontWeight: 600 }}>Proofreading</span>}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={manualSupportTypes.includes("PTA")}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setManualSupportTypes(prev => [...prev, "PTA"]);
                                                } else {
                                                    setManualSupportTypes(prev => prev.filter(t => t !== "PTA"));
                                                }
                                            }}
                                        />
                                    }
                                    label={<span style={{ fontSize: "13px", fontWeight: 600 }}>PTA</span>}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={manualSupportTypes.includes("CoC")}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setManualSupportTypes(prev => [...prev, "CoC"]);
                                                } else {
                                                    setManualSupportTypes(prev => prev.filter(t => t !== "CoC"));
                                                }
                                            }}
                                        />
                                    }
                                    label={<span style={{ fontSize: "13px", fontWeight: 600 }}>CoC</span>}
                                />
                            </FormGroup>

                            {/* Proofreading scope radio buttons */}
                            {manualSupportTypes.includes("Proofreading") && (
                                <Box sx={{ pl: 4, mt: 1, display: "flex", flexDirection: "column", gap: 0.5 }}>
                                    <RadioGroup
                                        row
                                        value={manualProofreadingScope}
                                        onChange={(e) => setManualProofreadingScope(e.target.value)}
                                    >
                                        <FormControlLabel value="Entire" control={<Radio size="small" />} label={<span style={{ fontSize: "12px" }}>Entire</span>} />
                                        <FormControlLabel value="Front Page & Claims" control={<Radio size="small" />} label={<span style={{ fontSize: "12px" }}>{formatActivityLabel("Front Page & Claims")}</span>} />
                                        <FormControlLabel value="Front Page, Claims & Drawings" control={<Radio size="small" />} label={<span style={{ fontSize: "12px" }}>{formatActivityLabel("Front Page, Claims & Drawings")}</span>} />
                                    </RadioGroup>
                                </Box>
                            )}
                        </Box>

                        {/* 2. Client Dropdown */}
                        <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                            <InputLabel id="manual-client-label">Select Client</InputLabel>
                            <Select
                                labelId="manual-client-label"
                                value={manualClientCode}
                                label="Select Client"
                                onChange={(e) => setManualClientCode(e.target.value)}
                                sx={{ backgroundColor: "#fff" }}
                            >
                                {clients.map(c => (
                                    <MenuItem key={c.tenantCode || c.code} value={c.tenantCode || c.code}>
                                        {c.tenantName ? `${c.tenantName} (${c.tenantCode || c.code})` : (c.clientName || c.name || c.tenantCode || c.code)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {/* 3. Enter Application Numbers */}
                        <TextField
                            label="Enter Application Numbers"
                            placeholder="Please enter the application numbers separated by new line(s)."
                            helperText="Please enter the application numbers separated by new line(s)."
                            value={manualApplicationNumbers}
                            onChange={(e) => setManualApplicationNumbers(e.target.value)}
                            fullWidth
                            multiline
                            rows={3}
                            size="small"
                            sx={{ backgroundColor: "#fff" }}
                        />
                    </DialogContent>
                    <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #E2E8F0" }}>
                        <Button variant="secondary" onClick={handleCloseManualEntry} sx={{ mr: 'auto' }}>
                            Cancel
                        </Button>
                        <Button variant="secondary" onClick={handleResetManualEntry} sx={{ borderColor: BRAND_COLORS.PRIMARY, color: BRAND_COLORS.PRIMARY }}>
                            Reset
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleSubmitManualEntry}
                            disabled={
                                manualSubmitting ||
                                !manualClientCode ||
                                !manualApplicationNumbers.trim() ||
                                manualSupportTypes.length === 0 ||
                                (manualSupportTypes.includes("Proofreading") && !manualProofreadingScope)
                            }
                        >
                            {manualSubmitting ? <CircularProgress size={18} color="inherit" /> : "Submit"}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Admin Edit Dialog */}
                <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)} maxWidth="sm" fullWidth
                    PaperProps={{ sx: { borderRadius: "12px" } }}
                >
                    <DialogTitle sx={{ fontWeight: 600, fontSize: "20px", pb: 1, borderBottom: "1px solid #E2E8F0" }}>
                        Edit Task Details
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, fontWeight: 400 }}>
                            Admin can modify imported basic details. If extracted values need correction.
                        </Typography>
                    </DialogTitle>
                    <DialogContent sx={{ pt: "16px !important" }}>
                        <TextField
                            label="Application/Patent Number"
                            value={editForm.applicationNo}
                            onChange={(e) => setEditForm(prev => ({ ...prev, applicationNo: e.target.value }))}
                            fullWidth margin="dense" size="small"
                        />
                        <FormControl fullWidth margin="dense" size="small">
                            <InputLabel>Support Type (Work Type)</InputLabel>
                            <Select
                                value={editForm.supportType}
                                label="Support Type (Work Type)"
                                onChange={(e) => {
                                    const nextSupportType = e.target.value;
                                    setEditForm(prev => {
                                        let nextActivityName = prev.activityName;
                                        if (nextSupportType === "PTA") {
                                            nextActivityName = "PTA";
                                        } else if (nextSupportType === "CoC") {
                                            nextActivityName = "CoC";
                                        } else if (nextSupportType === "Proofreading") {
                                            const validProofreadingActivities = ["Entire", "Front Page & Claims", "Front Page, Claims & Drawings"];
                                            if (!validProofreadingActivities.includes(prev.activityName)) {
                                                nextActivityName = "Entire";
                                            }
                                        }
                                        return {
                                            ...prev,
                                            supportType: nextSupportType,
                                            activityName: nextActivityName
                                        };
                                    });
                                }}
                            >
                                <MenuItem value="Proofreading">Proofreading</MenuItem>
                                <MenuItem value="PTA">PTA</MenuItem>
                                <MenuItem value="CoC">CoC</MenuItem>
                            </Select>
                        </FormControl>
                        {editForm.supportType === "Proofreading" ? (
                            <FormControl fullWidth margin="dense" size="small">
                                <InputLabel>Activity</InputLabel>
                                <Select
                                    value={editForm.activityName}
                                    label="Activity"
                                    onChange={(e) => setEditForm(prev => ({ ...prev, activityName: e.target.value }))}
                                >
                                    <MenuItem value="Entire">Entire</MenuItem>
                                    <MenuItem value="Front Page & Claims">{formatActivityLabel("Front Page & Claims")}</MenuItem>
                                    <MenuItem value="Front Page, Claims & Drawings">{formatActivityLabel("Front Page, Claims & Drawings")}</MenuItem>
                                </Select>
                            </FormControl>
                        ) : (
                            <TextField
                                label="Activity"
                                value={editForm.activityName}
                                onChange={(e) => setEditForm(prev => ({ ...prev, activityName: e.target.value }))}
                                fullWidth margin="dense" size="small"
                                disabled
                            />
                        )}
                        <TextField
                            label="Current Status"
                            value={editTask?.taskStatus || ""}
                            disabled
                            fullWidth margin="dense" size="small"
                        />
                        <FormControl fullWidth margin="dense" size="small" disabled={editTask?.taskStatus !== "In Progress" && editTask?.taskStatus !== "Under Review"}>
                            <InputLabel>Status Correction Override</InputLabel>
                            <Select
                                value={editForm.taskStatus}
                                label="Status Correction Override"
                                onChange={(e) => setEditForm(prev => ({ ...prev, taskStatus: e.target.value }))}
                            >
                                {Object.values(TASK_STATUSES).map(s => (
                                    <MenuItem key={s} value={s}>{s}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {(editTask?.taskStatus !== "In Progress" && editTask?.taskStatus !== "Under Review") && (
                            <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5, ml: 1 }}>
                                Status override is only permitted for tasks currently in "In Progress" or "Under Review" status.
                            </Typography>
                        )}
                        {editForm.taskStatus !== editTask?.taskStatus && (
                            <TextField
                                label="Reason for Change"
                                placeholder="Reason for Change"
                                value={editForm.statusOverrideReason || ""}
                                onChange={(e) => setEditForm(prev => ({ ...prev, statusOverrideReason: e.target.value }))}
                                fullWidth margin="dense" size="small"
                                required
                            />
                        )}
                        <Box sx={{
                            backgroundColor: "#FEF3C7",
                            color: "#92400E",
                            border: "1px solid #FDE68A",
                            borderRadius: "8px",
                            padding: "10px 14px",
                            mt: 2,
                            fontSize: "12px",
                            fontWeight: 500,
                            lineHeight: 1.5
                        }}>
                            Status override requires audit log. Previous status, updated status, user, date-time, and reason will be recorded.
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #E2E8F0" }}>
                        <Button variant="secondary" onClick={() => setEditDialogOpen(false)}>Cancel</Button>
                        <Button variant="primary" onClick={handleSaveEdit} disabled={editSubmitting}>
                            {editSubmitting ? <CircularProgress size={18} color="inherit" /> : "Save"}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Confirm status override Dialog */}
                <Dialog open={confirmOverrideOpen} onClose={() => setConfirmOverrideOpen(false)} maxWidth="xs" fullWidth
                    PaperProps={{ sx: { borderRadius: "12px", p: 1 } }}
                >
                    <DialogTitle sx={{ fontWeight: 700, fontSize: "18px", pb: 0.5 }}>
                        Confirm status override
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, fontWeight: 400 }}>
                            This change will reset the task assignment.
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="body2" sx={{ color: "#374151", mb: 2, mt: 1 }}>
                            Are you sure you want to apply this change? This action will unassign the case from the current user.
                        </Typography>
                        <Box sx={{
                            backgroundColor: "#FEF2F2",
                            color: "#991B1B",
                            border: "1px solid #FEE2E2",
                            borderRadius: "6px",
                            padding: "10px 12px",
                            fontSize: "13px",
                            fontWeight: 500,
                            lineHeight: 1.5
                        }}>
                            {overrideType === "processor" ? (
                                "In Process -> To Do: assigned Processor is unassigned and task returns to default assignment state."
                            ) : (
                                "Under Review -> QC Pending: assigned QA is unassigned and task returns to default assignment state."
                            )}
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button variant="secondary" onClick={() => setConfirmOverrideOpen(false)}>No</Button>
                        <Button variant="primary" onClick={executeSaveEdit} disabled={editSubmitting}>
                            {editSubmitting ? <CircularProgress size={18} color="inherit" /> : "Yes"}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Submit Confirmation Dialog */}
                <Dialog
                    open={confirmOpen}
                    onClose={() => setConfirmOpen(false)}
                    PaperProps={{ sx: { borderRadius: 3, minWidth: 400, p: 1 } }}
                >
                    <DialogTitle sx={{ fontWeight: 700, fontSize: "18px", color: "#1a1a2e", pb: 1 }}>
                        Confirm Submission
                    </DialogTitle>
                    <DialogContent sx={{ pb: 2 }}>
                        <Typography variant="body2" sx={{ color: "#374151", lineHeight: 1.6 }}>
                            {confirmTask ? getSubmitConfirmMessage(
                                getSubmitTarget(confirmTask),
                                confirmTask,
                                getStagedQaId(confirmTask)
                            ) : ""}
                        </Typography>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2.5 }}>
                        <Button variant="secondary" onClick={() => setConfirmOpen(false)}>No</Button>
                        <Button variant="primary" onClick={handleConfirmedSubmit}>
                            {submittingTaskId ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Yes"}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* File History Modal */}
                <Dialog
                    open={!!fileHistoryTaskId}
                    onClose={() => setFileHistoryTaskId(null)}
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{ sx: { borderRadius: "12px" } }}
                >
                    <DialogTitle sx={{ fontWeight: 600, fontSize: "16px", borderBottom: "1px solid #E2E8F0" }}>
                        File History — {fileHistoryTaskId}
                    </DialogTitle>
                    <DialogContent sx={{ pt: "16px !important", minHeight: 150 }}>
                        {fileHistoryLoading ? (
                            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                                <CircularProgress size={28} sx={{ color: BRAND_COLORS.PRIMARY }} />
                            </Box>
                        ) : fileHistory.length === 0 ? (
                            <Typography color="text.secondary" sx={{ py: 4, textAlign: "center" }}>
                                No files uploaded yet.
                            </Typography>
                        ) : (
                            <List dense>
                                {fileHistory.map((pkg) => (
                                    <ListItem
                                        key={pkg.version}
                                        secondaryAction={
                                            <Tooltip title="Download">
                                                <IconButton
                                                    edge="end"
                                                    onClick={() => handleVersionDownload(fileHistoryTaskId, pkg.version, pkg.fileName)}
                                                    disabled={downloadingVersion === pkg.version}
                                                    sx={{ color: BRAND_COLORS.PRIMARY }}
                                                >
                                                    {downloadingVersion === pkg.version
                                                        ? <CircularProgress size={18} color="inherit" />
                                                        : <DownloadIcon fontSize="small" />}
                                                </IconButton>
                                            </Tooltip>
                                        }
                                        sx={{ borderBottom: "1px solid #F1F5F9", py: 1 }}
                                    >
                                        <ListItemIcon sx={{ minWidth: 36 }}>
                                            <InsertDriveFileOutlinedIcon sx={{ fontSize: 20, color: "#64748B" }} />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={
                                                <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                                                    v{pkg.version} — {pkg.fileName || "Unnamed"}
                                                </Typography>
                                            }
                                            secondary={
                                                <Typography sx={{ fontSize: "11px", color: "#94A3B8" }}>
                                                    {pkg.modifiedBy ? `By: ${pkg.modifiedBy}` : ""}
                                                    {pkg.modifiedAt ? ` · ${new Date(pkg.modifiedAt).toLocaleString()}` : ""}
                                                </Typography>
                                            }
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        )}
                    </DialogContent>
                    <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #E2E8F0" }}>
                        <Button variant="secondary" onClick={() => setFileHistoryTaskId(null)}>Close</Button>
                        {canUploadFile(userRole, tasks.find(t => t.taskId === fileHistoryTaskId)?.taskStatus, tasks.find(t => t.taskId === fileHistoryTaskId), oaUserId) && (
                            <Button
                                variant="primary"
                                startIcon={<CloudUploadOutlinedIcon />}
                                onClick={() => { setFileHistoryTaskId(null); handleFileUpload(fileHistoryTaskId); }}
                            >
                                Upload New
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>

                {/* Actions Dropdown Menu */}
                <Menu
                    anchorEl={menuAnchorEl}
                    open={Boolean(menuAnchorEl)}
                    onClose={() => {
                        setMenuAnchorEl(null);
                        setMenuTask(null);
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {(() => {
                        if (!menuTask) return null;
                        
                        const localProcessorId = getStagedProcessorId(menuTask);
                        const localQaId = getStagedQaId(menuTask);
                        const submitTarget = getSubmitTarget(menuTask);
                        // COL-158: upload-optional clients satisfy the Processor gate without a file
                        const hasFiles = hasRequiredPackages(menuTask, menuTask.packages && menuTask.packages.length > 0);
                        const submitEnabled = isSubmitEnabled(menuTask, hasFiles, userRole, localProcessorId, localQaId);
                        const disabledReason = getSubmitDisabledReason(menuTask, hasFiles, userRole, localProcessorId, localQaId);
                        const isReassignDisabled = !menuTask.processorId && !menuTask.qaId && menuTask.processorName !== "Processing Skipped";
                        const canUpload = canUploadFile(userRole, menuTask.taskStatus, menuTask, oaUserId);
                        const latestFile = hasFiles ? [...menuTask.packages].sort((a, b) => b.version - a.version)[0] : null;
                        const isSubmitting = submittingTaskId === menuTask.taskId;
                        // COL-133: Submit & Assign are not applicable to Completed tasks
                        const isCompleted = menuTask.taskStatus === "Completed";

                        return [
                            // 0. Rush/Priority toggle (Admin/AM only, not for Completed — COL-135)
                            isAppManager && !isCompleted && (
                                <MenuItem
                                    key="rush"
                                    onClick={() => {
                                        setMenuAnchorEl(null);
                                        setMenuTask(null);
                                        handleToggleRush(menuTask);
                                    }}
                                    sx={{ fontSize: "14px" }}
                                >
                                    <BoltIcon sx={{ fontSize: 18, mr: 1.5, color: "#DC2626" }} />
                                    {menuTask.isRush ? "Remove Rush Priority" : "Mark as Rush Priority"}
                                </MenuItem>
                            ),

                            // 1. Submit Action (hidden for Completed)
                            !isCompleted && (
                            <Tooltip key="submit-tip" title={disabledReason || (submitTarget ? "Submit" : "No submit action available")} arrow placement="left">
                                <span>
                                    <MenuItem
                                        disabled={!submitTarget || !submitEnabled || isSubmitting}
                                        onClick={() => {
                                            setMenuAnchorEl(null);
                                            setMenuTask(null);
                                            handleSubmitClick(menuTask);
                                        }}
                                        sx={{ fontSize: "14px" }}
                                    >
                                        <SendIcon sx={{ fontSize: 18, mr: 1.5, color: BRAND_COLORS.PRIMARY }} />
                                        {isSubmitting ? <CircularProgress size={14} /> : "Submit"}
                                    </MenuItem>
                                </span>
                            </Tooltip>
                            ),

                            // 2. Assign Action (hidden for Completed)
                            isAppManager && !isCompleted && (
                                <Tooltip key="assign-tip" title={isReassignDisabled ? "Initial assignment must be completed first" : ""} arrow placement="left">
                                    <span>
                                        <MenuItem
                                            disabled={isReassignDisabled}
                                            onClick={() => {
                                                setMenuAnchorEl(null);
                                                setMenuTask(null);
                                                setReassignTask(menuTask);
                                            }}
                                            sx={{ fontSize: "14px" }}
                                        >
                                            <PersonAddOutlinedIcon sx={{ fontSize: 18, mr: 1.5, color: BRAND_COLORS.PRIMARY }} />
                                            Assign
                                        </MenuItem>
                                    </span>
                                </Tooltip>
                            ),

                            // 3. Edit Action (hidden for Completed)
                            isAppManager && !isCompleted && (
                                <MenuItem
                                    key="edit"
                                    onClick={() => {
                                        setMenuAnchorEl(null);
                                        setMenuTask(null);
                                        handleOpenEdit(menuTask);
                                    }}
                                    sx={{ fontSize: "14px" }}
                                >
                                    <EditOutlinedIcon sx={{ fontSize: 18, mr: 1.5, color: BRAND_COLORS.PRIMARY }} />
                                    Edit
                                </MenuItem>
                            ),

                            // 4. Track Changes Action
                            isInternalRole && (
                                <MenuItem
                                    key="track"
                                    onClick={() => {
                                        setMenuAnchorEl(null);
                                        setMenuTask(null);
                                        setTrackChangesTaskId(menuTask.taskId);
                                    }}
                                    sx={{ fontSize: "14px" }}
                                >
                                    <AdsClickIconCustom sx={{ fontSize: 18, mr: 1.5, color: BRAND_COLORS.PRIMARY }} />
                                    Track Changes
                                </MenuItem>
                            ),

                            // 5. Attach File Action
                            canUpload && (
                                <MenuItem
                                    key="attach"
                                    onClick={() => {
                                        setMenuAnchorEl(null);
                                        setMenuTask(null);
                                        handleFileUpload(menuTask.taskId);
                                    }}
                                    sx={{ fontSize: "14px" }}
                                >
                                    <AttachFileIcon sx={{ fontSize: 18, mr: 1.5, color: BRAND_COLORS.PRIMARY }} />
                                    Attach File
                                </MenuItem>
                            ),

                            // 6. Download File Action
                            hasFiles && (
                                <MenuItem
                                    key="download"
                                    onClick={() => {
                                        setMenuAnchorEl(null);
                                        setMenuTask(null);
                                        handleFileDownload(menuTask.taskId, latestFile?.fileName);
                                    }}
                                    sx={{ fontSize: "14px" }}
                                >
                                    <DownloadIcon sx={{ fontSize: 18, mr: 1.5, color: BRAND_COLORS.PRIMARY }} />
                                    Download File
                                </MenuItem>
                            ),

                            // 7. View File History Action
                            hasFiles && (
                                <MenuItem
                                    key="history"
                                    onClick={() => {
                                        setMenuAnchorEl(null);
                                        setMenuTask(null);
                                        openFileHistory(menuTask.taskId);
                                    }}
                                    sx={{ fontSize: "14px" }}
                                >
                                    <HistoryIcon sx={{ fontSize: 18, mr: 1.5, color: BRAND_COLORS.PRIMARY }} />
                                    View File History
                                </MenuItem>
                            )
                        ];
                    })()}
                </Menu>

                {/* Snackbar */}
                <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                    <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%', boxShadow: 3 }}>
                        {snackbar.message}
                    </Alert>
                </Snackbar>
            </Box>
        </ThemeProvider>
    );
};

export default PGSTaskList;
